import mqtt from 'mqtt'
import * as APIs from '../services/apis';
import config from '../config'
import * as UAParser from 'ua-parser-js'
import { dataURLtoFile } from '../utils/helperFunctions'
import { FLOW, BACK_INDICATORS, EXCLUDE_INDICATORS, XIAOMI_MODEL_CODES } from './../constants';
import { getEnvironmentFromDomain } from './../utils/helperFunctions';
import HUL_OVERLAY from './assets/3_ROSES_OVERLAY.png';
import CNH_OVERLAY from './assets/CNH_OVERLAY.png';
import NESTLE_OVERLAY from './assets/NESTLE_OVERLAY.png';
import GOODKNIGHT_OVERLAY from './assets/GoodKnight.png';
import IRIDIUM_OVERLAY from './assets/IRIDIUM_OVERLAY.png';
import { webLogger } from '../tracing';
const TickIcon =
  'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/TickIcon-1.png';
const ErrorIcon =
  'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/ErrorIcon-1.png';
const ArrowIcon =
  'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/UpperArrow.svg';
const CANNOT_CONFIRM_ICON = 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/CANNOT_CONFIRM.png';
const LOADER_IMAGE_URL = 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/Enno_Loader.webp';
const RESULT_CONFIGURATIONS = {
            'GENUINE': {
                'icon': 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/vyu_brand_engagement/icon/GENUINE_ICON_V2.png',
                'text': 'This is a genuine product',
                'status': 'Genuine',
                'scanAgainButton': 'Scan Again',
                'button1': 'Know More',
                'statusColour': 'rgba(65, 173, 73, 1)',
                'textBgColour': 'rgba(65, 172, 72, 0.1)',
                'bgColour': 'rgba(247, 255, 248, 1)',
                'button1Link': 'https://ennoventure.com/',
                'button1Icon': 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/vyu_brand_engagement/icon/MORE_DETAILS_ARROW.png'
            },
            'FAKE': {
                'icon': 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/vyu_brand_engagement/icon/ERROR_ICON_V2.png',
                'text': 'Product could not be verified',
                'status': 'Unable to Authenticate',
                'scanAgainButton': 'Scan Again',
                'button1': 'Know More',
                'bgColour': 'rgba(255, 239, 239, 1)',
                'statusColour': 'rgba(255, 0, 0, 1)',
                'textBgColour': 'rgba(255, 214, 214, 1)',
                'button1Link': 'wa.me/918828286861?text=Send%20Picture',
                'button2Link': 'https://ennoventure.com/',
                'button1Icon': 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/vyu_brand_engagement/icon/MORE_DETAILS_ARROW.png',
                'button2Icon': 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/vyu_brand_engagement/icon/MORE_DETAILS_ARROW.png'
            },
            'CANNOT_CONFIRM': {
                'icon': 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/static/CANNOT_CONFIRM.png',
                'text': 'Could not verify the product reliably, please try again.',
                'status': 'Try Again',
                'scanAgainButton': 'Scan Again',
                'button1': 'Know More',
                'bgColour': 'rgba(255, 244, 213, 1)',
                'statusColour': 'rgba(170, 126, 0, 1)',
                'textBgColour': 'rgba(255, 234, 175, 1)',
                'button1Link': 'https://ennoventure.com/',
                'scanAgainIcon': 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/vyu_brand_engagement/icon/SCAN_AGAIN_ICON_V2.png',
                'button1Icon': 'https://ennoventure-public-assets.s3.us-east-1.amazonaws.com/vyu_brand_engagement/icon/MORE_DETAILS_ARROW.png'
            },
        };
const MQTT_CONFIG = {
  url: 'wss://mqttlistener.ops.enncrypto.com:8084/mqtt',
  username: 'admin',
  password: 'ennoventure@123',
};
const MQTT_PROD_CONFIG = {
  url: 'wss://emqxlistener.ops.enncrypto.com/mqtt',
  username: 'admin',
  password: 'z2gP5Y1QXhO9',
};
const MQTT_QA_CONFIG = {
  url: 'wss://dev-emqxlistener.ops.enncrypto.com/mqtt',
  username: 'admin',
  password: '8hEg1F3q3KuP1qy',
};
const BIFROST_URLS = {
  DEV_IMAGE_STREAM: 'https://bifrost-plana.ops.enncrypto.com',
  DEV_VIDEO_STREAM: 'https://bifrost-dev.ops.enncrypto.com',
  PROD_IMAGE_STREAM: 'https://bifrost.ops.enncrypto.com',
  PROD_VIDEO_STREAM: 'https://bifrost.ops.enncrypto.com',
};
interface Detection {
  coords: number[]
  label: string
  probability: number
  type: string
  result: string
  prediction_result: 2
  prediction: false
  sessionId: string
  productConfigId: string
}

export default class VideoSDK {
  private videoElement: HTMLVideoElement
  private mqttClient: mqtt.MqttClient | null = null
  private peerConnection: RTCPeerConnection | null = null
  private scannerElem: HTMLElement = document.body
  private videoOffsetWidth!: number
  private videoOffsetHeight!: number
  private canvas: HTMLCanvasElement
  private ctx: CanvasRenderingContext2D
  private mqttSessionExpireTopic = ''
  public intervalId: NodeJS.Timeout | null = null
  private sessionId = ''
  private detectionQueue: string[]
  private resultsShown = false
  private stream = MediaStream
  private sendImagesToTopic = false
  private rejectCount = 0
  private acceptCount = 0
  private cannotConfirmCount = 0
  private planB = false
  private isTest = false
  private interval: NodeJS.Timeout | null = null
  private toggleBrandEngagement = () => { }
  private messageHandler
  private overlay = ''
  private toast = ''
  private isProductIdentified = false
  private stopProcessingDetects = false
  private gridCells: HTMLDivElement[] = []
  private bubbleThresholdDistance = 20 // Configurable distance to retain existing bubbles
  private minBubbles = 5 // Minimum number of bubbles
  private maxBubbles = 10 // Maximum number of bubbles
  private bubbleRemovalTimer: any = null
  private currentBubbles: { x: number; y: number; element: HTMLDivElement }[] = []
  private timeout: NodeJS.Timeout | null = null
  private detectionTimeout: NodeJS.Timeout | null = null
  private tenSecondTimeout: NodeJS.Timeout | null = null
  private lastRect
  private lastCheckedTime = 0
  private showRestart = false
  private stopMonitoring = null
  private bandwidth = 0
  private bandwidthResults = {};
  private legacySessionId = ''
  private accessToken = ''
  private legacyImageCount = 0
  private isSessionStarted = false
  private imageCount = 0
  private pollingInitiated = false
  private cords = {}
  private flow = ''
  private environment = ''
  private bifrostUrl = ''
  private posthogEvent
  private languageConfig: any
  private brandEngagementLink = ''
  private brandEngagementData = {};
  private showBrandPopup = false;
  private loadingStartTime: number;
  private ipLocation: any;
  private clientId = '';
  private appConfig: any;
  private uidConfig: any;
  private decoderConfigId = '';
  private productConfigId = '';
  private showGenuinePopupCallback: ((config: any) => void) | null = null;
  private showReportPopupCallback: ((config: any) => void) | null = null;
  private genuinePopupActive = false;
  private ipAddress: any;

  constructor(videoElement: HTMLVideoElement) {
    this.videoElement = videoElement
    this.detectionQueue = []
    this.canvas = document.createElement('canvas')
    this.ctx = this.canvas.getContext('2d')!
    this.canvas.id = 'myCanvas'
    this.scannerElem.appendChild(this.canvas)
    this.canvas.style.position = 'absolute'
    this.canvas.style.top = `${this.videoElement.offsetTop}px`
    this.canvas.style.left = `${this.videoElement.offsetLeft}px`
    this.videoElement.addEventListener('loadeddata', this.updateCanvasSize)
    window.addEventListener('resize', this.updateCanvasSize)
    setTimeout(() => {
      window.addEventListener('beforeunload', (event) => {
        this.cleanup()
        event.preventDefault()
      })
      window.addEventListener('unload', () => {
        this.cleanup()
      })
    }, 5000)
  }

  public setBandwidth(bandwidthResults: any) {
    this.bandwidthResults = bandwidthResults;
  }

  public async init(
    flow = '',
    sendVideo = true,
    toggleBrandEngagement: any, // Adjust type as needed
    posthogEvent: any,
    ipLocation: any,
    languageConfig: any,
    clientId: any,
    appConfig: any,
    uidConfig: any,
    ipAddress: any,
    showGenuinePopup?: (config: any) => void,
    showReportPopup?: (config: any) => void,
  ): Promise<void> {
    try {
      console.log('Initializing VideoSDK...', uidConfig);
      const currentUrl = window.location.href;
      const urlObj = new URL(currentUrl);
      this.flow = flow
      this.resultsShown = false
      this.sendImagesToTopic = false
      this.toggleBrandEngagement = toggleBrandEngagement
      this.stopProcessingDetects = false
      this.isProductIdentified = false
      this.showRestart = false
      this.legacySessionId = ''
      this.accessToken = ''
      this.legacyImageCount = 0
      this.isSessionStarted = false
      this.imageCount = 0
      this.pollingInitiated = false
      this.brandEngagementLink = '';
      this.clientId = clientId || urlObj?.searchParams?.get('uId') || 'UNKNOWN';
      this.ipLocation = ipLocation;
      this.decoderConfigId = '';
      this.productConfigId = '';
      this.appConfig = appConfig || {};
      this.uidConfig = uidConfig || {};
      this.ipAddress = ipAddress || {};
 
      this.showGenuinePopupCallback = showGenuinePopup || null;
      this.showReportPopupCallback = showReportPopup || null;
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.cords = {
        lat: ipLocation && ipLocation.latitude ? ipLocation.latitude : 'UNKNOWN',
        long: ipLocation && ipLocation.longitude ? ipLocation.longitude : 'UNKNOWN',
        source: ipLocation && ipLocation.source ? ipLocation.source : 'UNKNOWN',
      }

      this.rejectCount = 0
      this.acceptCount = 0
      this.cannotConfirmCount = 0;
      this.posthogEvent = posthogEvent;
      this.languageConfig = languageConfig || {};
      if (navigator.geolocation) {
        try {
          const coords = await this.getCachedGeolocation();
          this.cords = {
            lat: coords.lat,
            long: coords.long,
            source: 'geolocation'
          }
          console.log('Coordinates set:', this.cords)
        } catch (error) {
          webLogger.error('Error fetching coordinates', error);
          console.error('Error fetching coordinates:', error.message)
        }
      } else {
        console.warn('Geolocation not supported by this browser.')
      }

      const env = getEnvironmentFromDomain();
      this.environment = env
      this.setBifrostUrl(this.environment)
      this.initializeMQTT()
      this.clearOverlay().then(() => {
        this.createOverlay()
        this.startVideoStream(0, 3, sendVideo)
      })
    } catch (error) {
      webLogger.error('Error initializing VideoSDK', error);
      console.error('Error initializing VideoSDK:', error)
    }
  }

  public updateLocation(ipLocation: any) {
    if (ipLocation && ipLocation.source !== this.cords.source) {
      this.cords = {
        lat: ipLocation && ipLocation.latitude ? ipLocation.latitude : 'UNKNOWN',
        long: ipLocation && ipLocation.longitude ? ipLocation.longitude : 'UNKNOWN',
        source: ipLocation && ipLocation.source ? ipLocation.source : 'UNKNOWN',
        isUpdated: true,
      }
      this.posthogEvent.sendPostHogEvent('location_updated', {
        sessionId: this.sessionId,
        ...this.cords
      });
    }
  }

  public setAppConfig(appConfig: any) {
    this.appConfig = appConfig || {};
  }

  private getCachedGeolocation(): Promise<{ lat: number, long: number }> {
  const CACHE_KEY = 'user_geolocation_cache';
  const CACHE_TIMESTAMP = 'user_geolocation_timestamp';
  const CACHE_DURATION = 5 * 60 * 1000;

  try {
    const cached = localStorage.getItem(CACHE_KEY);
    const timestamp = localStorage.getItem(CACHE_TIMESTAMP);

    if (cached && timestamp) {
      const age = Date.now() - parseInt(timestamp);
      const cachedCoords = JSON.parse(cached);
      
      if (age < CACHE_DURATION) {
        console.log('Coordinates loaded from cache:', cachedCoords);
        console.log('Updating location in background...');
        this.updateLocationInBackground();
        
        return Promise.resolve(cachedCoords);
      }
    }
  } catch (error) {
    webLogger.warn(`Error checking geolocation cache: ${error.message || ''}`,{});
    console.warn('Error checking geolocation cache:', error);
  }
  return this.fetchFreshLocation();
}

private updateLocationInBackground(): void {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const coords = {
        lat: position.coords.latitude,
        long: position.coords.longitude
      };
      
      try {
        localStorage.setItem('user_geolocation_cache', JSON.stringify(coords));
        localStorage.setItem('user_geolocation_timestamp', Date.now().toString());
        console.log('Background location update completed:', coords);
      } catch (error) {
        webLogger.warn(`Error updating background location: ${error.message || ''}`,{});
        console.warn('Error updating background location:', error);
      }
    },
    (error) => {
      console.warn('Background geolocation update failed:', error.message);
    },
    {
      enableHighAccuracy: false,
      timeout: 15000,
      maximumAge: 0,
    }
  );
}

private fetchFreshLocation(): Promise<{ lat: number, long: number }> {
  return new Promise((resolve, reject) => {
    console.log('Fetching fresh coordinates...');

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const coords = {
          lat: position.coords.latitude,
          long: position.coords.longitude
        };
        
        try {
          localStorage.setItem('user_geolocation_cache', JSON.stringify(coords));
          localStorage.setItem('user_geolocation_timestamp', Date.now().toString());
          console.log('Fresh coordinates fetched and cached:', coords);
        } catch (error) {
          webLogger.warn(`Error saving coordinates to cache ${error.message || ''}`, {});
          console.warn('Error saving coordinates to cache:', error);
        }

        resolve(coords);
      },
      (error) => {
        console.error('Geolocation error:', error.message);
        try {
          const cachedData = localStorage.getItem('user_geolocation_cache');
          if (cachedData) {
            const cachedCoords = JSON.parse(cachedData);
            console.log('Using expired cache as fallback:', cachedCoords);
            resolve(cachedCoords);
            return;
          }
        } catch (cacheError) {
          console.warn('Error retrieving expired cache:', cacheError);
        }

        reject(error);
      },
      {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 30 * 60 * 1000,
      }
    );
  });
}

  private setBifrostUrl(environment = 'qa') {
    const BIFROST_URLS = {
      DEV_IMAGE_STREAM: 'https://bifrost-plana.ops.enncrypto.com',
      DEV_VIDEO_STREAM: 'https://d.api.enncrypto.com',
      QA_IMAGE_STREAM: 'https://q.api.enncrypto.com',
      QA_VIDEO_STREAM: 'https://q.api.enncrypto.com',
      STAGE_IMAGE_STREAM: 'https://s.api.enncrypto.com',
      STAGE_VIDEO_STREAM: 'https://s.api.enncrypto.com',
      PROD_IMAGE_STREAM: 'https://api.enncrypto.com',
      PROD_VIDEO_STREAM: 'https://api.enncrypto.com',
    }
    const flowKey = this.flow
    const key = `${environment.toUpperCase()}_${flowKey}`
    this.bifrostUrl = BIFROST_URLS[key] || BIFROST_URLS.QA_VIDEO_STREAM
  }


  private startVideoStream = async (retryCount = 0, maxRetries = 3, sendVideo = true) => {
    const FRAME_RATE = this.flow === FLOW.VIDEO_STREAM ? 6 : 10;
    let currentQualityTier = 0
    const currentUrl = window.location.href
    const urlObj = new URL(currentUrl)
    const isDemo = urlObj.searchParams.get('isDemo');
    const isVietnam = this.ipAddress && this.ipAddress.country_name === 'Vietnam';
    const XIOMI_MODEL_CODES = new Set(XIAOMI_MODEL_CODES);
    const ua = new UAParser.UAParser();
    const deviceDetails = ua.getResult();
    const deviceModel = deviceDetails.device.model || '';
    const isXiaomiDevice = XIOMI_MODEL_CODES.has(deviceModel);
    console.log('isVietnam:', isVietnam, 'isXiaomiDevice:', isXiaomiDevice, 'isDemo:', isDemo, 'deviceModel:', deviceModel);
    const resWidth = isVietnam || isXiaomiDevice || isDemo ? 1920 : 2160;
    const resHeight = isVietnam || isXiaomiDevice || isDemo ? 1080 : 1440;
    // Define quality tiers, but we'll try to use device maximum if VIDEO_STREAM
    // For IMAGE_STREAM we'll still use these fallback tiers
    const qualityTiers = [
      { width: resWidth, height: resHeight, frameRate: FRAME_RATE }, // 4K
      { width: resWidth, height: resHeight, frameRate: FRAME_RATE }, // 1080p
    ]

    try {
      const devices = await navigator.mediaDevices.enumerateDevices()
      const videoDevices = devices.filter((device) => device.kind === 'videoinput')

      // Check for camera URL parameter (camera=1,2,3...)
      const currentUrl = window.location.href;
      const urlObj = new URL(currentUrl);
      const cameraParam = urlObj.searchParams.get('camera');

      // Detect iPhone Pro and Pro Max devices using a more reliable approach
      // Function to detect if device is likely an iPhone Pro/Pro Max
      const detectiPhonePro = () => {
        // Check for iPhone in user agent
        const isiPhone = /iPhone/.test(navigator.userAgent);
        if (!isiPhone) return false;

        // Get device memory - Pro models typically have more RAM
        // This isn't fully reliable but can help with detection
        const deviceMemory = navigator.deviceMemory || 0;

        // Get screen dimensions with pixel ratio
        const pixelRatio = window.devicePixelRatio || 1;
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const scaledWidth = screenWidth * pixelRatio;
        const scaledHeight = screenHeight * pixelRatio;

        console.log(`Device info - Screen: ${screenWidth}x${screenHeight}, Pixel ratio: ${pixelRatio}, Scaled: ${scaledWidth}x${scaledHeight}, Memory: ${deviceMemory}GB`);

        // Pro models have higher pixel ratios and specific screen dimensions
        // iPhone Pro/Pro Max typically have 3x pixel ratio
        if (pixelRatio >= 3) {
          // Check for camera count - if we can access it
          if (videoDevices.length >= 3) {
            console.log('Multiple cameras detected, likely a Pro model');
            return true;
          }

          // Pro models tend to have these screen dimensions
          // These ranges catch most Pro models regardless of exact pixel values
          if (
            // Pro and Pro Max typical ranges
            (screenWidth >= 390 && screenWidth <= 430 && screenHeight >= 840 && screenHeight <= 950) ||
            // For landscape orientation
            (screenHeight >= 390 && screenHeight <= 430 && screenWidth >= 840 && screenWidth <= 950)
          ) {
            console.log('Screen dimensions match Pro/Pro Max models');
            return true;
          }
        }

        return false;
      };

      //   Check if this is an iPhone Pro model and set camera parameter accordingly
      // if (!cameraParam && false) {
      //   cameraParam = '6';
      //   console.log('iPhone Pro/Pro Max detected, automatically setting camera=4');
      // }

      // Prefer back camera using facingMode, with deviceId as a fallback
      let selectedDeviceId = null;
      let selectedCameraLabel = ''; // Added to store the selected camera label

      if (cameraParam && videoDevices.length > 0) {
        // If camera parameter exists, try to select that camera by index (1-based)
        const cameraIndex = parseInt(cameraParam) - 1; // Convert to 0-based index
        if (!isNaN(cameraIndex) && cameraIndex >= 0 && cameraIndex < videoDevices.length) {
          // Valid camera index, use it
          selectedDeviceId = videoDevices[cameraIndex].deviceId;
          selectedCameraLabel = videoDevices[cameraIndex].label || `Camera ${cameraIndex + 1}`; // Store the label
          console.log(`Using camera ${cameraIndex + 1} specified by URL parameter or device detection`);
        } else {
          console.warn(`Invalid camera parameter: ${cameraParam}. Using default camera selection logic.`);
        }
      }
      // Create a function to handle Vietnamese accent normalization specifically
      const normalizeVietnamese = (str) => {
        return str
          .replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, 'a')
          .replace(/[èéẹẻẽêềếệểễ]/g, 'e')
          .replace(/[ìíịỉĩ]/g, 'i')
          .replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, 'o')
          .replace(/[ùúụủũưừứựửữ]/g, 'u')
          .replace(/[ỳýỵỷỹ]/g, 'y')
          .replace(/đ/g, 'd')
          .replace(/[ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ]/g, 'A')
          .replace(/[ÈÉẸẺẼÊỀẾỆỂỄ]/g, 'E')
          .replace(/[ÌÍỊỈĨ]/g, 'I')
          .replace(/[ÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ]/g, 'O')
          .replace(/[ÙÚỤỦŨƯỪỨỰỬỮ]/g, 'U')
          .replace(/[ỲÝỴỶỸ]/g, 'Y')
          .replace(/Đ/g, 'D');
      };

      // Updated camera detection logic
      if (!selectedDeviceId && videoDevices.length > 0) {
        for (const device of videoDevices) {
          const label = device.label.toLowerCase();
          const labelNormalized = normalizeVietnamese(label);

          console.log('device', device);

          const isBackCamera = BACK_INDICATORS.some((indicator) => {
            const indicatorLower = indicator.toLowerCase();
            const indicatorNormalized = normalizeVietnamese(indicatorLower);

            // Try both original and normalized versions
            return label.includes(indicatorLower) || labelNormalized.includes(indicatorNormalized);
          });

          const isExcluded = EXCLUDE_INDICATORS.some((indicator) => {
            const indicatorLower = indicator.toLowerCase();
            const indicatorNormalized = normalizeVietnamese(indicatorLower);

            // Try both original and normalized versions
            return label.includes(indicatorLower) || labelNormalized.includes(indicatorNormalized);
          });

          if (isBackCamera && !isExcluded) {
            selectedDeviceId = device.deviceId;
            selectedCameraLabel = device.label;
          }
        }

        if (!selectedDeviceId) {
          selectedDeviceId = videoDevices[0]?.deviceId;
          selectedCameraLabel = videoDevices[0]?.label || 'Default Camera';
        }
      }
      const ua = new UAParser.UAParser()
      const deviceDetails = ua.getResult()
      this.posthogEvent.sendPostHogEvent('media_devices', {
          verificationSessionId: this.legacySessionId,
          sessionId: this.sessionId,
          selectedDeviceId,
          selectedCameraLabel,
          cameraList: JSON.stringify(videoDevices),
          deviceDetails,
        });

      // Get device capabilities first to determine optimal constraints
      const maxWidth = resWidth;
      const maxHeight = resHeight;
      const maxFrameRate = FRAME_RATE;

      // Check if this is an Android device
      const isAndroid = /Android/i.test(navigator.userAgent);

      // Add focus mode for Android devices
      const focusModeConstraint = { focusMode: { ideal: 'continuous' } };

      // Initial minimal constraints to get access to the device
      const initialConstraints = {
        video: {
          facingMode: { ideal: 'environment' },
          ...(selectedDeviceId && { deviceId: { exact: selectedDeviceId } }),
          ...focusModeConstraint, // Add focus mode for Android
        },
        audio: false,
      };

      // First, get a temporary stream to check device capabilities
      const tempStream = await navigator.mediaDevices.getUserMedia(initialConstraints);
      const videoTrack = tempStream.getVideoTracks()[0];

      if (videoTrack && typeof videoTrack.getCapabilities === 'function') {
        const capabilities = videoTrack.getCapabilities();
        console.log('Camera capabilities:', capabilities);

        // Stop the temporary stream
        videoTrack.stop();
      } else {
        // If getCapabilities is not supported, stop the temporary stream
        tempStream.getTracks().forEach(track => track.stop());
      }

      // Now set up constraints based on the flow type
      let optimalConstraints;
      const maxConstraint = false;
      if (this.flow === FLOW.VIDEO_STREAM && maxConstraint) {
        // For VIDEO_STREAM, use the maximum resolution the device supports
        optimalConstraints = {
          width: { ideal: maxWidth },
          height: { ideal: maxHeight },
          frameRate: { ideal: maxFrameRate },
          ...focusModeConstraint, // Add focus mode for Android
        };
        console.log(`Using maximum device resolution: ${maxWidth}x${maxHeight}@${maxFrameRate}fps for VIDEO_STREAM`);
      } else {
        // For IMAGE_STREAM, use the existing constraints
        optimalConstraints = {
          width: { min: resWidth, ideal: resWidth, max: resWidth },
          height: { min: resHeight, ideal: resHeight, max: resHeight },
          frameRate: { min: FRAME_RATE, ideal: FRAME_RATE, max: FRAME_RATE },
          ...focusModeConstraint, // Add focus mode for Android
        };
      }

      const baseConstraints = {
        video: {
          facingMode: { ideal: 'environment' },
          ...(selectedDeviceId && { deviceId: { exact: selectedDeviceId } }),
          ...optimalConstraints,
        },
        audio: false,
      };

      let stream = null;
      try {
        // Try to get stream with optimal constraints
        stream = await navigator.mediaDevices.getUserMedia(baseConstraints);
      } catch (highQualityError) {
        webLogger.warn(`Could not get stream with optimal constraints: ${highQualityError.message}`, {});
        console.warn('Could not get stream with optimal constraints:', highQualityError);

        // Try fallback qualities
        for (let i = 0; i < qualityTiers.length; i++) {
          try {
            const videoConstraints = {
              ...(selectedDeviceId && { deviceId: { exact: selectedDeviceId } }),
              facingMode: { ideal: 'environment' },
              ...qualityTiers[i],
              ...focusModeConstraint, // Add focus mode for Android
            };

            stream = await navigator.mediaDevices.getUserMedia({
              video: videoConstraints,
              audio: false,
            });

            currentQualityTier = i;
            if (stream?.getVideoTracks().length > 0) {
              break;
            }
          } catch (err) {
            console.warn(`Quality tier ${i} failed: ${err?.message}`);
            if (i === qualityTiers.length - 1) {
              // Last resort: try with minimal constraints
              stream = await navigator.mediaDevices.getUserMedia({
                video: {
                  facingMode: 'environment',
                  ...(selectedDeviceId && { deviceId: { exact: selectedDeviceId } }),
                  ...focusModeConstraint, // Add focus mode for Android
                },
                audio: false,
              });
            }
          }
        }
      }

      if (stream && stream.getVideoTracks().length > 0) {
        const videoTrack = stream.getVideoTracks()[0];

        // Try to apply constraints one more time (this helps on some devices)
        if (this.flow === FLOW.VIDEO_STREAM) {
          try {
            await videoTrack.applyConstraints({
              width: { ideal: maxWidth },
              height: { ideal: maxHeight },
              frameRate: { ideal: maxFrameRate },
              ...focusModeConstraint, // Add focus mode for Android
            });
          } catch (constraintErr) {
            webLogger.warn(`Could not apply high quality constraints: ${constraintErr.message || ''}`, {});
            console.warn('Could not apply high quality constraints:', constraintErr);
          }
        } else {
          try {
            await videoTrack.applyConstraints({
              width: { min: resWidth, ideal: resWidth, max: resWidth },
              height: { min: resHeight, ideal: resHeight, max: resHeight },
              frameRate: { min: FRAME_RATE, ideal: FRAME_RATE, max: FRAME_RATE },
              ...focusModeConstraint, // Add focus mode for Android
            });
          } catch (constraintErr) {
            webLogger.warn(`Could not apply high quality constraints: ${constraintErr.message || ''}`, {});
            console.warn('Could not apply standard quality constraints:', constraintErr);
          }
        }

        if (this.videoElement) {
          this.videoElement.srcObject = stream;
        }
        this.stream = stream;

        const settings = videoTrack.getSettings();
        console.log('Stream started with settings:', {
          width: settings.width,
          height: settings.height,
          frameRate: settings.frameRate,
          focusMode: settings.focusMode || 'not supported/reported', // Log the focus mode if available
        });

        console.log('Track constraints:', videoTrack.getConstraints());
        this.posthogEvent.sendPostHogEvent('view_finder_opened', {
          result: 'success',
          verificationSessionId: this.legacySessionId,
          sessionId: this.sessionId,
          cameraLabel: selectedCameraLabel // Include the camera label in the event
        });
        this.startRTCConnection(stream, sendVideo);

        return;
      } else {
        throw new Error('No video tracks available');
      }
    } catch (error) {
      webLogger.error('Error accessing video stream', error);
      console.error('Error accessing video stream:', error);
      this.posthogEvent.sendPostHogEvent('view_finder_opened', {
        result: 'failed',
        error: error?.name,
        sessionId: this.sessionId,
      });
      switch (error?.name) {
        case 'OverconstrainedError':
          if (retryCount < maxRetries) {
            console.warn('Constraints too strict, retrying with fallback...');
            setTimeout(() => {
              this.startVideoStream(retryCount + 1, maxRetries, true);
            }, 500);
            return;
          }
          break;

        case 'NotAllowedError':
        case 'NotReadableError':
          console.warn('Camera access denied or locked');
          if (retryCount < maxRetries) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
            return this.startVideoStream(retryCount + 1, maxRetries, true);
          }
          break;

        case 'NotFoundError':
          console.error('No camera device found');
          break;

        default:
          console.error('Unexpected error:', error);
      }

      if (retryCount >= maxRetries) {
        console.error('Failed to start video stream after maximum retries.');
      }
    }
  }

  private startQualityAdjustment = (videoTrack, qualityTiers, currentTier) => {
    let currentQualityTier = currentTier

    const adjustQuality = async () => {
      try {
        // Use this.bandwidth instead of downlinkSpeed
        const bandwidth = this.bandwidth || 0 // Mbps

        // Define bandwidth thresholds based on requirement
        const threshold = 5 // Mbps threshold for 4K

        let targetTier = currentQualityTier
        if (bandwidth > threshold && currentQualityTier > 0) {
          targetTier = 0 // Upgrade to 4K
        } else if (bandwidth <= threshold && bandwidth > 0 && currentQualityTier < 1) {
          targetTier = 1 // Downgrade to 1080p
        }

        if (targetTier !== currentQualityTier) {
          const newConstraints = qualityTiers[targetTier]
          await videoTrack.applyConstraints({
            width: { ideal: newConstraints.width },
            height: { ideal: newConstraints.height },
            frameRate: { ideal: newConstraints.frameRate },
            contentHint: 'detail'
          })

          currentQualityTier = targetTier
          console.log(
            `Quality adjusted to ${newConstraints.width}x${newConstraints.height}@${newConstraints.frameRate}fps`,
          )

          // Update RTC connection with new stream settings
          if (this.peerConnection) {
            const senders = this.peerConnection.getSenders()
            senders.forEach((sender) => {
              if (sender.track?.kind === 'video') {
                sender.replaceTrack(videoTrack)
              }
            })
          }
        }
      } catch (err) {
        webLogger.warn(`Failed to adjust video quality ${err.message || ''}`,{})
        console.warn('Failed to adjust video quality:', err)
      }
    }

    // Check and adjust quality every 5 seconds
    setInterval(adjustQuality, 5000)
  }

  private startRTCConnection = async (stream, sendVideo): Promise<void> => {
    console.log('Starting RTC connection setup...')

    this.peerConnection = new RTCPeerConnection({
      iceServers: [
        {
          urls: 'turn:3.227.0.206:3478',
          username: 'admin',
          credential: 'webkul123',
        },
        {
          urls: 'turn:3.239.83.210:3478',
          username: 'admin',
          credential: 'webkul123',
        },
      ],
      iceTransportPolicy: 'all',
      rtcpMuxPolicy: 'require',
      // Enable these options for better performance
      bundlePolicy: 'max-bundle',
      iceCandidatePoolSize: 10,
    })

    // Event listeners (enhanced for better monitoring and recovery)
    this.peerConnection.addEventListener('iceconnectionstatechange', () => {
      console.log('ICE connection state change:', this.peerConnection?.iceConnectionState)
      if (this.peerConnection?.iceConnectionState === 'failed') {
        console.error('ICE connection failed. Attempting reconnection...')
        this.attemptICERestart()
        this.posthogEvent.sendPostHogEvent('webrtc_connection_failed', {
          sessionId: this.sessionId,
          message: 'iceconnectionstatechange - ICE connection failed. Attempting reconnection..',
        });
      }
    })

    this.peerConnection.addEventListener('icecandidate', (event) => {
      if (event.candidate) {
        console.log('New ICE candidate:', event.candidate)
      } else {
        console.log('All ICE candidates have been gathered.')
      }
    })

    this.peerConnection.addEventListener('connectionstatechange', () => {
      console.log('Connection state change:', this.peerConnection?.connectionState)
      if (this.peerConnection?.connectionState === 'failed') {
        console.error('Connection failed. Attempting recovery...')
        this.attemptConnectionRecovery()
        this.posthogEvent.sendPostHogEvent('webrtc_connection_failed', {
          sessionId: this.sessionId,
          message: 'connectionstatechange - ICE connection failed. Attempting reconnection..',
        });
      }
    })

    this.peerConnection.addEventListener('track', (event) => {
      console.log('Track event received:', event)
      if (event.track.kind === 'video') {
        // Handle incoming tracks if needed
        this.monitorIncomingVideoQuality(event.track)
      }
    })
    if (sendVideo) {
      this.sendVideo()
      return
    } else {
      return;
    }

    // Create an initial offer without tracks
    try {
      const offer = await this.peerConnection.createOffer({
        offerToReceiveVideo: true,
        offerToReceiveAudio: false,
      })
      // Set high bitrate - increased from 5Mbps to 10Mbps
      offer.sdp = this.setMaxBitrate(offer.sdp, 10000000)
      await this.peerConnection.setLocalDescription(new RTCSessionDescription(offer))
      console.log('Local description set. Signaling state:', this.peerConnection.signalingState)
    } catch (error) {
      console.error('Error creating initial offer or setting local description:', error)
      return
    }

    // Increased ICE gathering timeout for more complete candidate collection
    const iceGatheringTimeout = 8000
    const iceGatheringPromise = new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject('ICE gathering timeout'), iceGatheringTimeout)

      const checkState = () => {
        console.log('ICE gathering state change:', this.peerConnection?.iceGatheringState)
        if (this.peerConnection?.iceGatheringState === 'complete') {
          clearTimeout(timeout)
          this.peerConnection?.removeEventListener('icegatheringstatechange', checkState)
          resolve(null)
        }
      }

      if (this.peerConnection?.iceGatheringState === 'complete') {
        clearTimeout(timeout)
        resolve(null)
      } else {
        this.peerConnection?.addEventListener('icegatheringstatechange', checkState)
      }
    })

    try {
      await iceGatheringPromise
      console.log('ICE gathering complete for initial setup')
    } catch (error) {
      console.warn('ICE gathering timed out, proceeding with available candidates:', error)
    }

    // Send initial offer to signaling server
    setTimeout(() => {
      if (this.peerConnection && this.peerConnection.localDescription) {
        const currentUrl = window.location.href
        const urlObj = new URL(currentUrl)
        const showLogs = urlObj.searchParams.get('showLogs')
        console.log('Sending initial offer to signaling server...')
        this.sendBifrostSignal(this.peerConnection, this.peerConnection.localDescription)
        if (showLogs) {
          // this.startBandwidthMonitoring()
          //this.startQualityMonitoring() // New function to monitor video quality
        }
        console.log('Initial signal sent:', this.peerConnection.localDescription)
      } else {
        console.error('PeerConnection or local description not available.')
      }
    }, 500)
  }

  // New method for quality monitoring
  private startQualityMonitoring = (): void => {
    if (!this.peerConnection) return;

    const monitoringInterval = setInterval(() => {
      if (!this.peerConnection) {
        clearInterval(monitoringInterval);
        return;
      }

      this.peerConnection.getStats().then(stats => {
        stats.forEach(report => {
          if (report.type === 'outbound-rtp' && report.kind === 'video') {
            console.log('Video stats:', {
              resolution: `${report.frameWidth}x${report.frameHeight}`,
              frameRate: report.framesPerSecond,
              qualityLimitationReason: report.qualityLimitationReason,
              packetsLost: report.packetsLost,
              nackCount: report.nackCount,
              firCount: report.firCount,
              pliCount: report.pliCount,
              bytesSent: report.bytesSent
            });

            // If we detect quality issues, try to adjust parameters
            if (report.qualityLimitationReason === 'bandwidth') {
              this.optimizeForLowBandwidth();
            }
          }
        });
      });
    }, 5000); // Check every 5 seconds
  }

  // New method to optimize for low bandwidth
  private optimizeForLowBandwidth = (): void => {
    console.log('Optimizing for low bandwidth...');
    // Instead of reducing resolution, we'll adjust other parameters
    // to maintain high quality even under bandwidth constraints

    // 1. Renegotiate with priority on key frames and error resilience
    this.peerConnection?.getStats().then(stats => {
      let videoSender: RTCRtpSender | null = null;

      this.peerConnection?.getSenders().forEach(sender => {
        if (sender.track?.kind === 'video') {
          videoSender = sender;
        }
      });

      if (videoSender) {
        const parameters = videoSender.getParameters();
        parameters.degradationPreference = 'maintain-resolution';
        // Keep the resolution high but optimize other parameters
        if (parameters.encodings && parameters.encodings.length > 0) {
          // Prioritize quality over framerate
          // Use SVC (Scalable Video Coding) if available
          parameters.encodings.forEach(encoding => {
            // Maintain resolution but reduce framerate slightly if needed
            encoding.maxFramerate = 6; // Still looks smooth but saves bandwidth

            // Set scaleResolutionDownBy to 1 to maintain full resolution
            encoding.scaleResolutionDownBy = 1;

            // Prioritize quality
            encoding.networkPriority = 'high';

            // Increase max bitrate limit (in bps)
            encoding.maxBitrate = 8000000; // 8 Mbps
          });

          videoSender.setParameters(parameters).catch(err => {
            webLogger.error('Error setting parameters', err);
            console.error('Error setting parameters:', err);
          });
        }
      }
    });
  }

  // New method for connection recovery
  private attemptConnectionRecovery = async (): Promise<void> => {
    console.log('Attempting connection recovery...');

    if (!this.peerConnection) return;

    // First try an ICE restart
    await this.attemptICERestart();

    // If still failing after 3 seconds, try a full reconnection
    setTimeout(() => {
      if (this.peerConnection?.connectionState === 'failed') {
        console.log('ICE restart unsuccessful, attempting full reconnection');
        this.restartFullConnection();
      }
    }, 3000);
  }

  // New method for ICE restart
  private attemptICERestart = async (): Promise<void> => {
    console.log('Attempting ICE restart...');

    if (!this.peerConnection) return;

    try {
      const offer = await this.peerConnection.createOffer({
        iceRestart: true,
        offerToReceiveVideo: true,
        offerToReceiveAudio: false
      });

      offer.sdp = this.setMaxBitrate(offer.sdp, 10000000);
      await this.peerConnection.setLocalDescription(offer);

      // Wait for ICE gathering with new candidates
      await new Promise<void>(resolve => {
        const checkState = () => {
          if (this.peerConnection?.iceGatheringState === 'complete') {
            this.peerConnection.removeEventListener('icegatheringstatechange', checkState);
            resolve();
          }
        };

        this.peerConnection.addEventListener('icegatheringstatechange', checkState);
        setTimeout(resolve, 5000); // Timeout after 5 seconds
      });

      if (this.peerConnection.localDescription) {
        this.sendBifrostSignal(this.peerConnection, this.peerConnection.localDescription);
      }
    } catch (error) {
      webLogger.error('ICE restart failed', error);
      console.error('ICE restart failed:', error);
    }
  }

  // New method for full reconnection
  private restartFullConnection = (): void => {
    console.log('Performing full connection restart...');

    // Clean up existing connection
    this.peerConnection?.close();
    this.peerConnection = null;
    const oldSessionId = String(this.sessionId);
    const newSessionId = crypto.randomUUID();
    this.posthogEvent.sendPostHogEvent('restart_rtc_connection', {
      oldSessionId,
      newSessionId,
      message: 'Full connection restart initiated due to failure',
    });
    this.sessionId = newSessionId;
    // Start a new connection after a brief delay
    setTimeout(() => {
      if (this.stream) {
        this.startRTCConnection(this.stream, true);
      }
    }, 1000);
  }

 public sendVideo = async (stream: MediaStream = this.stream): Promise<void> => {
  console.log('Starting to send high-resolution video...')
  const bandwidth = this.bandwidthResults?.speedMbps || -1;
  const featureFlags = this.appConfig?.featureFlags || {};
  const isLowBandwidth = bandwidth && bandwidth > 0 && bandwidth < 1 ? true : false;
  const connectionType = this.getNetworkConnectionType();
  const isSlowConnection = connectionType === '3g' || connectionType === 'slow-3g' || connectionType === '2g' || connectionType === 'slow-2g';
  const XIOMI_MODEL_CODES = new Set(XIAOMI_MODEL_CODES);
  const ua = new UAParser.UAParser();
  const deviceDetails = ua.getResult();
  const deviceModel = deviceDetails.device.model || '';
   const isVietnam = this.ipAddress && this.ipAddress.country_name === 'Vietnam';
  const isXiaomiDevice = XIOMI_MODEL_CODES.has(deviceModel);
  const lowerResolution = isVietnam || isXiaomiDevice;
  console.log('isVietnam:', isVietnam, 'lowerResolution', lowerResolution, 'isXiaomiDevice:', isXiaomiDevice, 'deviceModel:', deviceModel);
  // Show popup if bandwidth is too low or on slow connection
  if (featureFlags.showLowBandwidthPopup && (isLowBandwidth || isSlowConnection)) {
    this.posthogEvent.sendPostHogEvent('low_bandwidth_popup_shown', {
      sessionId: this.sessionId,
      bandwidth,
      isLowBandwidth,
      isSlowConnection,
      connectionType
    });
    this.showLowBandwidthPopup();
    return; // Stop the connection process
  }
  
  // Start showing the loading GIF
  this.showLoadingGif();

  const videoTracks = stream.getVideoTracks()
  const videoTrack = videoTracks.length > 0 ? videoTracks[0] : null
  if (!videoTrack) {
    console.error('No video track available in the stream.')
    this.hideLoadingGif()
    return
  }

  this.stepOne()

  // Get device capabilities
  const capabilities = videoTrack.getCapabilities()
  console.log('Video capabilities:', capabilities)

  const currentUrl = window.location.href
  const urlObj = new URL(currentUrl)
  const isDemo = urlObj.searchParams.get('isDemo');

  // Force 1080p resolution
  const resWidth = lowerResolution || isDemo ? 1920 : 2160;
  const resHeight = lowerResolution || isDemo ? 1080 : 1440;

  const maxWidth = capabilities.width?.max ?? resWidth
  const maxHeight = capabilities.height?.max ?? resHeight

  const maxFrameRate = capabilities.frameRate?.max ?? 6

  const width = Math.min(maxWidth, resWidth)
  const height = Math.min(maxHeight, resHeight)

  const frameRate = Math.min(maxFrameRate, 6);

  console.log(`Using resolution: ${width}x${height} @ ${frameRate}fps`)

  const qualityProfile = {
    resolution: {
      width: { max: width, ideal: width, min: Math.floor(width * 0.9) }, 
      height: { max: height, ideal: height, min: Math.floor(height * 0.9) },
      frameRate: { max: frameRate, ideal: frameRate, min: 2 }, 
      contentHint: lowerResolution ? 'detail' : ''
    },
    sdpTweaks: [
      [
        /a=rtpmap:(\d+) VP9\/\d+\r\n/g,
        (match: string, p1: string) =>
          `${match}a=fmtp:${p1} profile-id=0;x-google-max-bitrate=12000;x-google-min-bitrate=4000;max-fs=8160;max-fr=15\r\n` +
          `a=rtcp-fb:${p1} nack\r\n` +
          `a=rtcp-fb:${p1} nack pli\r\n` +
          `a=rtcp-fb:${p1} ccm fir\r\n` +
          `a=rtcp-fb:${p1} transport-cc\r\n`
      ],
      [
        /a=rtpmap:(\d+) H264\/\d+\r\n/g,
        (match: string, p1: string) =>
          `${match}a=fmtp:${p1} level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=64001f;max-mbps=983040;max-fs=8160;x-google-max-bitrate=12000;x-google-min-bitrate=4000\r\n` +
          `a=rtcp-fb:${p1} nack\r\n` +
          `a=rtcp-fb:${p1} nack pli\r\n` +
          `a=rtcp-fb:${p1} ccm fir\r\n` +
          `a=rtcp-fb:${p1} transport-cc\r\n`
      ],
      [
        /a=rtpmap:(\d+) AV1\/\d+\r\n/g,
        (match: string, p1: string) =>
          `${match}a=fmtp:${p1} x-google-max-bitrate=10000;x-google-min-bitrate=3000\r\n` +
          `a=rtcp-fb:${p1} nack\r\n` +
          `a=rtcp-fb:${p1} nack pli\r\n` +
          `a=rtcp-fb:${p1} ccm fir\r\n` +
          `a=rtcp-fb:${p1} transport-cc\r\n`
      ],
    ],
  }

  try {
    await videoTrack.applyConstraints(qualityProfile.resolution)
    console.log('Video constraints applied:', qualityProfile.resolution)
  } catch (err) {
    this.posthogEvent.sendPostHogEvent('video_constraints_failed', {
      sessionId: this.sessionId,
      error: err,
    });
    webLogger.warn(`Failed to apply video constraints: ${err.message || ''}`,{})
    console.warn('Failed to apply video constraints:', err.message)
    
    try {
      await videoTrack.applyConstraints({
        width: { max: width, ideal: width, min: Math.floor(width * 0.8) },
        height: { max: height, ideal: height, min: Math.floor(height * 0.8) },
        frameRate: { max: 5, ideal: frameRate, min: 2 }, 
        contentHint: lowerResolution ? 'detail' : ''
      })
    } catch (fallbackErr) {
      webLogger.error('Failed to apply fallback constraints:', fallbackErr)
      console.error('Failed to apply even fallback constraints:', fallbackErr.message)
    }
  }

  // Add video tracks to the connection
  const senders = new Map()
  stream.getTracks().forEach((track) => {
    console.log('Adding track:', track)
    const sender = this.peerConnection?.addTrack(track, stream)
    if (sender && track.kind === 'video') {
      senders.set('video', sender)
    }
  })

  if (senders.has('video')) {
    try {
      const videoSender = senders.get('video')
      const parameters = videoSender.getParameters()

      // Force resolution maintenance
      parameters.degradationPreference = 'maintain-resolution';

      if (!parameters.encodings) {
        // FIXED: More reasonable bitrates that won't force downscaling
        parameters.encodings = [
          { 
            rid: 'high', 
            active: true, 
            scaleResolutionDownBy: 1.0, 
            maxBitrate: 12000000, 
            minBitrate: 3000000,
            networkPriority: 'high',
            scalabilityMode: 'L1T1',
            adaptivePtime: false,
            googCpuOveruseDetection: false,
          },
          { 
            rid: 'medium', 
            active: true, 
            scaleResolutionDownBy: 1.0, 
            maxBitrate: 8000000, 
            minBitrate: 2000000,
            networkPriority: 'medium',
            googCpuOveruseDetection: false,
          }
        ]
      } else {
        parameters.encodings.forEach(encoding => {
          encoding.scaleResolutionDownBy = 1.0
          encoding.networkPriority = 'high'
          
          encoding.maxBitrate = 12000000;
          encoding.minBitrate = 3000000;
          
          encoding.scalabilityMode = 'L1T1'
          encoding.adaptivePtime = false
          encoding.priority = 'high'
        })
      }

      await videoSender.setParameters(parameters)
      console.log('Video sender parameters set with 1080p maintenance focus')
    } catch (err) {
      webLogger.warn(`Failed to set video sender parameters: ${err.message || err}`, {})
      console.warn('Failed to set encoding parameters:', err.message)
    }
  }

  // Renegotiate the session with the new track
  try {
    console.log('Current signaling state before offer:', this.peerConnection.signalingState)
    console.log('Creating offer for renegotiation...')
    const offer = await this.peerConnection.createOffer({
      offerToReceiveVideo: true,
      offerToReceiveAudio: false,
      iceRestart: true
    })
    console.log('Raw offer SDP:', offer.sdp)

    if (!offer.sdp || !offer.sdp.includes('m=video')) {
      console.error('SDP missing video section:', offer.sdp)
      this.hideLoadingGif()
      return
    }

    let modifiedSdp = this.setMaxBitrate(offer.sdp, 12000000)
    qualityProfile.sdpTweaks.forEach(([regex, replacer]) => {
      modifiedSdp = modifiedSdp.replace(regex, replacer)
    })
    modifiedSdp = this.ensureBundleGroup(modifiedSdp)
    modifiedSdp = this.addFEC(modifiedSdp)
    modifiedSdp = this.addRED(modifiedSdp)
    modifiedSdp = this.disableResolutionDownscaling(modifiedSdp)

    if(lowerResolution){
      modifiedSdp = this.force1080pInSDP(modifiedSdp)
    }

    if (!modifiedSdp.includes('a=group:BUNDLE')) {
      console.error('BUNDLE group still missing after ensureBundleGroup:', modifiedSdp)
      this.hideLoadingGif()
      return
    }

    const offerDesc = new RTCSessionDescription({ type: 'offer', sdp: modifiedSdp })
    console.log('Setting local description with modified SDP:', modifiedSdp)
    await this.peerConnection.setLocalDescription(offerDesc)
    console.log('Local description set. Signaling state:', this.peerConnection.signalingState)
    this.posthogEvent.sendPostHogEvent('webrtc_connection_offer_created', {
      sessionId: this.sessionId,
    });
  } catch (error) {
    this.posthogEvent.sendPostHogEvent('webrtc_connection_offer_error', {
      sessionId: this.sessionId,
      error: error,
    });
    webLogger.error('Error creating offer or setting local description:', error)
    console.error('Error creating offer or setting local description:', error?.message, error?.stack)
    this.hideLoadingGif()
    return
  }

  // Wait for ICE gathering
  const iceGatheringTimeout = 10000
  const iceGatheringPromise = new Promise<void>((resolve) => {
    const timeout = setTimeout(() => {
      console.warn('ICE gathering timed out.')
      resolve()
    }, iceGatheringTimeout)

    this.peerConnection?.addEventListener('icegatheringstatechange', () => {
      console.log('ICE gathering state:', this.peerConnection?.iceGatheringState)
      if (this.peerConnection?.iceGatheringState === 'complete') {
        clearTimeout(timeout)
        resolve()
      }
    })
  })

  await iceGatheringPromise
  console.log('ICE gathering done or timed out')

  // Send offer to signaling server
  setTimeout(() => {
    if (this.peerConnection && this.peerConnection.localDescription) {
      console.log('Sending offer to signaling server...')
      this.sendBifrostSignal(this.peerConnection, this.peerConnection.localDescription)
      console.log('Offer sent:', this.peerConnection.localDescription)
    } else {
      this.posthogEvent.sendPostHogEvent('webrtc_connection_local_description_error', {
        sessionId: this.sessionId,
        error: 'PeerConnection or local description missing',
      });
      console.error('PeerConnection or local description missing.')
      this.hideLoadingGif()
    }
  }, 100)

  // Add connection state change event listener
  this.peerConnection?.addEventListener('connectionstatechange', () => {
    console.log('Connection state:', this.peerConnection?.connectionState)
    const bandwidth = this.bandwidthResults?.speedMbps || -1;
    if (this.peerConnection?.connectionState === 'connected') {
      this.posthogEvent.sendPostHogEvent('webrtc_connection_established', {
        sessionId: this.sessionId,
      });
      this.hideLoadingGif()
      this.createToast(this.languageConfig.keepProductCentered, '#242424', '#FFFFFF', '');
      
      this.monitorActualResolution();
    }
  })
}

private force1080pInSDP = (sdp: string): string => {
  sdp = sdp.replace(/(a=rtpmap:\d+ .*\r\n)/g, (match) => {
    return match + 'a=imageattr:* send [x=1920,y=1080] recv [x=1920,y=1080]\r\n';
  });
  
  sdp = sdp.replace(/(m=video[^\r\n]*\r\n)/g, 
    '$1b=AS:12000\r\n');
    
  return sdp;
}

private monitorActualResolution = async (): Promise<void> => {
  if (!this.peerConnection) return;
  
  const stats = await this.peerConnection.getStats();
  stats.forEach(report => {
    if (report.type === 'outbound-rtp' && report.mediaType === 'video') {
      console.log('🎯 ACTUAL STREAMING RESOLUTION:', {
        width: report.frameWidth,
        height: report.frameHeight,
        fps: report.framesPerSecond,
        bitrate: report.bitrateSent || 'N/A',
        is1080p: report.frameWidth === 1920 && report.frameHeight === 1080
      });
    }
  });
}

  public showResultButtons(): void {
    const buttonContainer = document.querySelector('.result-button-container') as HTMLElement;
    if (buttonContainer && this.genuinePopupActive) {
      buttonContainer.style.opacity = '1';
      this.genuinePopupActive = false;
    }
  }

  // Add these new methods to your class
  private loadingGifElement: HTMLElement | null = null;

  private showLoadingGif = (): void => {
    // Remove existing loading GIF if present
    this.hideLoadingGif();

    // Create overlay container
    const overlay = document.createElement('div');
    overlay.id = 'loading-gif-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    `;

    // Create GIF image element
    const gifImg = document.createElement('img');
    gifImg.src = LOADER_IMAGE_URL;
    gifImg.alt = 'Loading...';
    gifImg.style.cssText = `
      max-width: 200px;
      max-height: 200px;
      width: auto;
      height: auto;
    `;

    // Append GIF to overlay
    overlay.appendChild(gifImg);
    
    // Append overlay to body
    document.body.appendChild(overlay);
    
    // Store reference for cleanup
    this.loadingGifElement = overlay;
  }

  private hideLoadingGif = (): void => {
    if (this.loadingGifElement) {
      this.loadingGifElement.remove();
      this.loadingGifElement = null;
    }
    
    // Also remove by ID as fallback
    const existingOverlay = document.getElementById('loading-gif-overlay');
    if (existingOverlay) {
      existingOverlay.remove();
    }
  }

  // Add these new methods to handle the loading message animation
  private loadingMessageElement: HTMLElement | null = null
  private loadingAnimationInterval: NodeJS.Timeout | null = null  // Changed type
  private dotCount = 0
  private loadingStartTime: number | null = null  // Added missing property
  private overlayElement: HTMLElement | null = null  // Added missing property

  private showLoadingMessage(): void {
    // Clean up any existing loading message first
    this.hideLoadingMessage();

    // Create the overlay element if it doesn't exist
    if (!this.overlayElement) {
      this.overlayElement = document.createElement('div')
      this.overlayElement.style.position = 'fixed'
      this.overlayElement.style.top = '0'
      this.overlayElement.style.left = '0'
      this.overlayElement.style.width = '100%'
      this.overlayElement.style.height = '100%'
      this.overlayElement.style.background = 'rgba(0, 0, 0, 0.99)' // Dark overlay for the entire viewport
      this.overlayElement.style.zIndex = '9998' // Just below the loading message

      document.body.appendChild(this.overlayElement)
    }

    // Create the loading message element if it doesn't exist
    if (!this.loadingMessageElement) {
      this.loadingMessageElement = document.createElement('div')
      this.loadingMessageElement.style.position = 'fixed'
      this.loadingMessageElement.style.top = '50%'
      this.loadingMessageElement.style.left = '50%'
      this.loadingMessageElement.style.transform = 'translate(-50%, -50%)'
      this.loadingMessageElement.style.background = 'rgb(0, 0, 0, 0.98)';
      this.loadingMessageElement.style.color = 'white'
      this.loadingMessageElement.style.padding = '12px 25px'
      this.loadingMessageElement.style.borderRadius = '10px'
      this.loadingMessageElement.style.fontFamily = 'Arial, sans-serif'
      this.loadingMessageElement.style.fontSize = '14px'
      this.loadingMessageElement.style.zIndex = '9999'
      this.loadingMessageElement.style.whiteSpace = 'pre'

      document.body.appendChild(this.loadingMessageElement)
    }

    // Reset dot count and start time
    this.dotCount = 0
    this.loadingStartTime = Date.now()

    // Update the loading message text initially
    this.updateLoadingDots()

    // Start the animation - ensure we clear any existing interval first
    if (this.loadingAnimationInterval) {
      clearInterval(this.loadingAnimationInterval)
    }

    this.loadingAnimationInterval = setInterval(() => {
      this.updateLoadingDots()
    }, 500) // Update every 500ms
  }

  private updateLoadingDots(): void {
    if (this.loadingMessageElement && this.loadingStartTime) {
      // Calculate elapsed seconds
      const elapsedMs = Date.now() - this.loadingStartTime;
      const elapsedSeconds = Math.floor(elapsedMs / 1000);

      // Reset after 15 seconds (cycle repeats)
      const cycleSeconds = elapsedSeconds % 15;

      // Update dot animation
      this.dotCount = (this.dotCount + 1) % 4;
      const dots = '.'.repeat(this.dotCount);
      const spaces = ' '.repeat(3 - this.dotCount);

      // Determine message based on elapsed time in current cycle
      let message = '';
      if (cycleSeconds <= 5) {
        message = this.languageConfig.establishingConnection_1;
      } else if (cycleSeconds <= 10) {
        message = this.languageConfig.establishingConnection_2;
      } else {
        message = this.languageConfig.establishingConnection_3;
      }

      this.loadingMessageElement.textContent = `${message}${dots}${spaces}`;
    }
  }

  private hideLoadingMessage(): void {
    // Clear the animation interval
    if (this.loadingAnimationInterval) {
      clearInterval(this.loadingAnimationInterval)
      this.loadingAnimationInterval = null
    }

    // Remove the alert(2) - this was likely for debugging
    // alert(2);

    // Remove the loading message element
    if (this.loadingMessageElement) {
      this.loadingMessageElement.remove()  // Use remove() instead of removeChild
      this.loadingMessageElement = null
    }

    // Reset loading start time
    this.loadingStartTime = null;

    // Remove the overlay element
    if (this.overlayElement) {
      this.overlayElement.remove()  // Use remove() instead of removeChild
      this.overlayElement = null
    }
  }

  // Add these new helper methods

  // Setup bandwidth adaptation to prioritize resolution over frame rate
  private setupBandwidthAdaptation = (videoSender: RTCRtpSender, targetWidth: number, targetHeight: number) => {
    if (!videoSender) return;

    // Monitor bandwidth conditions
    const lastBitrate = 0;
    let consecutiveLowBandwidthCount = 0;

    const bandwidthCheck = setInterval(async () => {
      try {
        const stats = await this.peerConnection.getStats(videoSender);
        let currentBitrate = 0;
        let currentWidth = 0;
        let currentHeight = 0;
        let currentFrameRate = 0;

        stats.forEach(report => {
          if (report.type === 'outbound-rtp' && report.kind === 'video') {
            const bytesSent = report.bytesSent;
            const timestamp = report.timestamp;

            if (this.lastBytesSent && this.lastTimestamp) {
              currentBitrate = 8 * (bytesSent - this.lastBytesSent) / (timestamp - this.lastTimestamp) * 1000;
            }

            this.lastBytesSent = bytesSent;
            this.lastTimestamp = timestamp;

            // Get current resolution and frame rate
            if (report.frameWidth) currentWidth = report.frameWidth;
            if (report.frameHeight) currentHeight = report.frameHeight;
            if (report.framesPerSecond) currentFrameRate = report.framesPerSecond;
          }
        });

        console.log(`Current stats: ${currentWidth}x${currentHeight} @ ${currentFrameRate}fps, bitrate: ${Math.round(currentBitrate / 1000)}kbps`);

        // Check if resolution dropped below target
        const resolutionDropped = currentWidth < targetWidth * 0.9 || currentHeight < targetHeight * 0.9;
        const lowBandwidth = currentBitrate < 10000000; // 10 Mbps threshold

        if (lowBandwidth) {
          consecutiveLowBandwidthCount++;
        } else {
          consecutiveLowBandwidthCount = 0;
        }

        // If bandwidth is consistently low for several checks
        if (consecutiveLowBandwidthCount >= 3 || resolutionDropped) {
          //console.log("Low bandwidth detected, adjusting parameters to maintain resolution...");

          // Get sender parameters
          const parameters = videoSender.getParameters();

          if (parameters.encodings && parameters.encodings.length > 0) {
            // Reduce frame rate before touching resolution
            const track = videoSender.track;
            if (track) {
              try {
                // Try reducing frame rate to maintain resolution
                await track.applyConstraints({
                  width: { ideal: targetWidth, min: Math.floor(targetWidth * 0.9) },
                  height: { ideal: targetHeight, min: Math.floor(targetHeight * 0.9) },
                  frameRate: { ideal: Math.max(currentFrameRate - 1, 1), min: 1 }
                });

                // Make sure resolution is maintained in sender parameters
                parameters.encodings.forEach(encoding => {
                  encoding.scaleResolutionDownBy = 1.0;
                });

                await videoSender.setParameters(parameters);
                //  console.log("Adjusted parameters to maintain resolution quality");
              } catch (err) {
                webLogger.warn(`Failed to adjust video parameters: ${err.message || ''}`, {});
                console.warn('Failed to adjust video parameters:', err.message);
              }
            }
          }
        }
      } catch (error) {
        webLogger.error('Error in bandwidth adaptation:', error);
        console.error('Error in bandwidth adaptation:', error);
      }
    }, 2000);

    // Store interval ID to clear it later if needed
    this.bandwidthCheckInterval = bandwidthCheck;
  }

  // Add RED (Redundant Encoding) for better error resilience
  private addRED = (sdp: string): string => {
    const videoSection = sdp.split('m=video')[1];
    if (!videoSection) return sdp;

    const lines = sdp.split('\r\n');
    let redPayloadType = 125; // Default RED payload type

    // Find an unused payload type
    while (sdp.includes(`a=rtpmap:${redPayloadType}`)) {
      redPayloadType++;
    }

    // Find the video media section
    for (let i = 0; i < lines.length; i++) {
      if (lines[i].startsWith('m=video')) {
        // Add RED payload type to the media line
        lines[i] = `${lines[i]} ${redPayloadType}`;

        // Find the right spot to add our new rtpmap
        for (let j = i + 1; j < lines.length; j++) {
          if (!lines[j].startsWith('a=rtpmap:') &&
            !lines[j].startsWith('a=rtcp:') &&
            !lines[j].startsWith('a=rtcp-fb:') &&
            !lines[j].startsWith('c=')) {

            // Insert RED rtpmap and fmtp
            lines.splice(j, 0, `a=rtpmap:${redPayloadType} red/90000`);
            break;
          }
        }
        break;
      }
    }

    return lines.join('\r\n');
  }

  // Disable any SDP features that might reduce resolution
  private disableResolutionDownscaling = (sdp: string): string => {
    // Remove any lines with scaleResolutionDownBy greater than 1
    let modifiedSdp = sdp.replace(/a=fmtp:.*scaleResolutionDownBy=[1-9][.0-9]*/g, (match) => {
      return match.replace(/scaleResolutionDownBy=[1-9][.0-9]*/, 'scaleResolutionDownBy=1.0');
    });

    // Add explicit quality maintenance
    if (!modifiedSdp.includes('a=rid:')) {
      const videoMediaIndex = modifiedSdp.indexOf('m=video');
      if (videoMediaIndex !== -1) {
        const videoSection = modifiedSdp.substring(videoMediaIndex);
        const endOfVideoSection = videoSection.indexOf('m=', 2);
        const videoSectionEnd = endOfVideoSection !== -1 ? videoMediaIndex + endOfVideoSection : modifiedSdp.length;

        // Add a streamid if not already present
        if (!videoSection.includes('a=msid:')) {
          const insertPosition = videoSectionEnd;
          modifiedSdp = modifiedSdp.substring(0, insertPosition) +
            'a=msid:highres highres-video\r\n' +
            modifiedSdp.substring(insertPosition);
        }
      }
    }

    return modifiedSdp;
  }

  // Enhanced method to add Forward Error Correction for better quality
  private addFEC = (sdp: string): string => {
    console.log('Adding Forward Error Correction to SDP...')
    if (!sdp) return ''

    const lines = sdp.split('\n')
    let videoSection = false

    for (let i = 0; i < lines.length; i++) {
      if (lines[i].startsWith('m=video')) {
        videoSection = true
      }

      // For each RTP payload type in the video section, add FEC
      if (videoSection && lines[i].startsWith('a=rtpmap:')) {
        const payloadType = lines[i].match(/a=rtpmap:(\d+)/)?.[1]
        if (payloadType) {
          // Check if this payload type already has FEC
          let hasRedFec = false
          for (let j = 0; j < lines.length; j++) {
            if (lines[j].includes(`a=rtpmap:${payloadType} red/`) ||
              lines[j].includes(`a=rtpmap:${payloadType} ulpfec/`)) {
              hasRedFec = true
              break
            }
          }

          // Add FEC feedback mechanisms if not already present
          if (!hasRedFec) {
            // Look for existing feedback mechanisms for this payload type
            let feedbackExists = false
            for (let j = i + 1; j < lines.length && !lines[j].startsWith('a=rtpmap:'); j++) {
              if (lines[j].startsWith(`a=rtcp-fb:${payloadType} `)) {
                feedbackExists = true
                // Ensure we have all the necessary feedback mechanisms
                const neededFeedback = [
                  `a=rtcp-fb:${payloadType} nack`,
                  `a=rtcp-fb:${payloadType} nack pli`,
                  `a=rtcp-fb:${payloadType} ccm fir`,
                  `a=rtcp-fb:${payloadType} transport-cc`
                ]

                for (const feedback of neededFeedback) {
                  let hasFeedback = false
                  for (let k = i + 1; k < lines.length && !lines[k].startsWith('a=rtpmap:'); k++) {
                    if (lines[k].trim() === feedback) {
                      hasFeedback = true
                      break
                    }
                  }

                  if (!hasFeedback) {
                    lines.splice(i + 1, 0, feedback)
                    i++
                  }
                }
                break
              }
            }

            // If no feedback mechanisms exist, add them all
            if (!feedbackExists) {
              lines.splice(i + 1, 0,
                `a=rtcp-fb:${payloadType} nack`,
                `a=rtcp-fb:${payloadType} nack pli`,
                `a=rtcp-fb:${payloadType} ccm fir`,
                `a=rtcp-fb:${payloadType} transport-cc`
              )
              i += 4
            }
          }
        }
      }
    }

    return lines.join('\n')
  }

  private setMaxBitrate = (sdp: string, maxBitrate: number): string => {
    console.log('Setting max bitrate...')
    if (!sdp) return ''

    const lines = sdp.split('\n')
    let videoSection = false
    let bitrateSet = false

    for (let i = 0; i < lines.length; i++) {
      if (lines[i].startsWith('m=video')) {
        videoSection = true
      }
      if (videoSection && lines[i].startsWith('b=AS')) {
        lines[i] = `b=AS:${maxBitrate / 1000}` // Convert to kbps
        bitrateSet = true
        break
      }
    }

    if (videoSection && !bitrateSet) {
      for (let i = 0; i < lines.length; i++) {
        if (lines[i].startsWith('m=video')) {
          lines.splice(i + 1, 0, `b=AS:${maxBitrate / 1000}`)
          // Also add TIAS (Transport Independent Application Specific) maximum bitrate
          lines.splice(i + 2, 0, `b=TIAS:${maxBitrate}`)
          break
        }
      }
    }

    return lines.join('\n')
  }

  // Enhanced method to ensure proper bundling
  private ensureBundleGroup = (sdp: string): string => {
    console.log('Ensuring BUNDLE group in SDP...')
    if (!sdp) {
      console.error('SDP is empty')
      return ''
    }

    const lines = sdp.split('\n')
    let hasBundle = false
    let videoMid: string | null = null
    let audioMid: string | null = null
    let dataMid: string | null = null

    // Scan SDP for BUNDLE and MID
    for (let i = 0; i < lines.length; i++) {
      if (lines[i].startsWith('a=group:BUNDLE')) {
        hasBundle = true
        console.log('Existing BUNDLE group found:', lines[i])
      }

      if (lines[i].startsWith('m=video')) {
        // Look for the mid in the video section
        for (let j = i + 1; j < lines.length && !lines[j].startsWith('m='); j++) {
          if (lines[j].startsWith('a=mid:')) {
            videoMid = lines[j].match(/a=mid:(.+)/)?.[1] || null
            break
          }
        }

        if (!videoMid) {
          // Fallback: assign MID '0' if not found
          videoMid = '0'
          lines.splice(i + 1, 0, 'a=mid:0')
          console.log('Added missing video MID: a=mid:0')
        }
      }

      if (lines[i].startsWith('m=audio')) {
        // Look for the mid in the audio section
        for (let j = i + 1; j < lines.length && !lines[j].startsWith('m='); j++) {
          if (lines[j].startsWith('a=mid:')) {
            audioMid = lines[j].match(/a=mid:(.+)/)?.[1] || null
            break
          }
        }
      }

      if (lines[i].startsWith('m=application')) {
        // Look for the mid in the data channel section
        for (let j = i + 1; j < lines.length && !lines[j].startsWith('m='); j++) {
          if (lines[j].startsWith('a=mid:')) {
            dataMid = lines[j].match(/a=mid:(.+)/)?.[1] || null
            break
          }
        }
      }
    }

    // Build BUNDLE group string with all available media types
    let bundleGroup = 'a=group:BUNDLE';
    if (videoMid) bundleGroup += ` ${videoMid}`;
    if (audioMid) bundleGroup += ` ${audioMid}`;
    if (dataMid) bundleGroup += ` ${dataMid}`;

    // Add or replace BUNDLE group
    if (!hasBundle && videoMid !== null) {
      lines.unshift(bundleGroup);
      console.log('Added BUNDLE group:', bundleGroup);
    } else if (hasBundle) {
      // Replace existing BUNDLE line with our comprehensive one
      for (let i = 0; i < lines.length; i++) {
        if (lines[i].startsWith('a=group:BUNDLE')) {
          lines[i] = bundleGroup;
          console.log('Updated BUNDLE group:', bundleGroup);
          break;
        }
      }
    } else if (!videoMid) {
      console.error('No video MID found in SDP; cannot add BUNDLE group');
    }

    return lines.join('\n');
  }

  // New method to monitor incoming video quality
  private monitorIncomingVideoQuality = (track: MediaStreamTrack): void => {
    console.log('Monitoring incoming video quality for track:', track.id);

    // Check incoming video statistics
    const monitoringInterval = setInterval(() => {
      if (!this.peerConnection || track.readyState === 'ended') {
        clearInterval(monitoringInterval);
        return;
      }

      this.peerConnection.getStats(track).then(stats => {
        stats.forEach(report => {
          if (report.type === 'inbound-rtp' && report.kind === 'video') {
            console.log('Incoming video stats:', {
              resolution: `${report.frameWidth}x${report.frameHeight}`,
              frameRate: report.framesPerSecond,
              packetsLost: report.packetsLost,
              jitter: report.jitter,
              bytesReceived: report.bytesReceived,
              framesDecoded: report.framesDecoded,
              framesDropped: report.framesDropped
            });

            // Request keyframe if we're seeing packet loss
            if (report.packetsLost > 0 && report.packetsLost % 30 === 0) {
              this.requestKeyFrame();
            }
          }
        });
      });
    }, 5000);
  }

  // New method to request a keyframe
  private requestKeyFrame = (): void => {
    console.log('Requesting keyframe due to packet loss...');

    this.peerConnection?.getSenders().forEach(sender => {
      if (sender.track?.kind === 'video') {
        // Create and send a PLI (Picture Loss Indication) RTCP packet
        try {
          const parameters = sender.getParameters();
          if (parameters.encodings && parameters.encodings.length > 0) {
            // This is a workaround to trigger a keyframe
            const oldPriority = parameters.encodings[0].networkPriority || 'low';
            parameters.encodings[0].networkPriority = 'high';
            sender.setParameters(parameters).then(() => {
              // Restore original priority
              parameters.encodings[0].networkPriority = oldPriority;
              sender.setParameters(parameters);
            });
          }
        } catch (err) {
          webLogger.warn(`Failed to request keyframe ${err.message || ''}`, {});
          console.warn('Failed to request keyframe:', err.message);
        }
      }
    });
  }

  public stopSendingVideo = async (): Promise<void> => {
    if (!this.peerConnection) {
      console.error('PeerConnection not initialized.')
      return
    }

    console.log('Stopping video transmission...')

    const senders = this.peerConnection.getSenders()
    const videoSender = senders.find((sender) => sender.track?.kind === 'video')

    if (videoSender && videoSender.track) {
      // Disable the track instead of removing it to keep the sender alive
      videoSender.track.enabled = false
      console.log('Video track disabled.')

      // Optionally renegotiate to inform the remote peer (not strictly necessary if remote doesn’t need to know)
      try {
        const offer = await this.peerConnection.createOffer({
          offerToReceiveVideo: true,
          offerToReceiveAudio: false,
        })
        offer.sdp = this.setMaxBitrate(offer.sdp, 5000000)
        await this.peerConnection.setLocalDescription(new RTCSessionDescription(offer))
        if (this.peerConnection.localDescription) {
          await this.sendBifrostSignal(this.peerConnection, this.peerConnection.localDescription)
          console.log(
            'Renegotiated offer without video sent:',
            this.peerConnection.localDescription,
          )
        }
      } catch (error) {
        webLogger.error('Error renegotiating after stopping video', error)
        console.error('Error renegotiating after stopping video:', error)
      }
    } else {
      console.log('No video sender found to stop.')
    }
  }
  // Modified sendBifrostSignal method with proper state handling
  // Modified sendBifrostSignal method with bandwidth check
  private async sendBifrostSignal(peerConnection: RTCPeerConnection, offer) {


    const currentUrl = window.location.href
    const urlObj = new URL(currentUrl)
    const flowParam = urlObj.searchParams.get('flow')
    const isDemo = urlObj.searchParams.get('isDemo');
    const uId = urlObj.searchParams.get('uId');
    const source = this.flow === FLOW.VIDEO_STREAM ? 'vyu-app-stream' : 'vyu-app'
    // Extract user agent
    const userAgent = window.navigator.userAgent

    // Detect phone model (simplified parsing from userAgent)
    let phone = 'Unknown'
    if (/iPhone/.test(userAgent)) {
      phone = 'iPhone'
      const versionMatch = userAgent.match(/iPhone OS (\d+_\d+)/)
      if (versionMatch) phone += ` (iOS ${versionMatch[1].replace('_', '.')})`
    } else if (/Android/.test(userAgent)) {
      phone = 'Android'
      const modelMatch = userAgent.match(/Android.*;\s([\w\s-]+)\sBuild/)
      if (modelMatch) phone = modelMatch[1] // e.g., "Samsung SM-G960U"
    }

    // Detect browser
    let browser = 'Unknown'
    if (/Chrome/.test(userAgent)) {
      browser = 'Chrome'
      const versionMatch = userAgent.match(/Chrome\/(\d+\.\d+)/)
      if (versionMatch) browser += ` ${versionMatch[1]}`
    } else if (/Firefox/.test(userAgent)) {
      browser = 'Firefox'
      const versionMatch = userAgent.match(/Firefox\/(\d+\.\d+)/)
      if (versionMatch) browser += ` ${versionMatch[1]}`
    } else if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
      browser = 'Safari'
      const versionMatch = userAgent.match(/Version\/(\d+\.\d+)/)
      if (versionMatch) browser += ` ${versionMatch[1]}`
    } else if (/Edg/.test(userAgent)) {
      browser = 'Edge'
      const versionMatch = userAgent.match(/Edg\/(\d+\.\d+)/)
      if (versionMatch) browser += ` ${versionMatch[1]}`
    }

    let geoLat = ''
    let geoLong = ''
    let geoSource = ''
    try {
      geoLat = this.cords?.lat?.toString()
      geoLong = this.cords?.long?.toString()
      geoSource = this.cords?.source || 'unknown'
    } catch (error) {
      webLogger.error('Failed to get geolocation', error)
      console.error('Failed to get geolocation:', error)
    }
    const storedDeviceModel = localStorage.getItem('deviceModel')
    const ua = new UAParser.UAParser()
    const deviceDetails = ua.getResult()
    const deviceModel = storedDeviceModel
      ? `${deviceDetails.device?.model} ${storedDeviceModel}`
      : deviceDetails.device?.model
    const enhancedDeviceDetails = {
      ...deviceDetails,
      device: {
        ...deviceDetails.device,
        model: deviceModel,
      },
    }
    try {
      this.posthogEvent.sendPostHogEvent('webrtc_connection_signal_triggered', {
        sessionId: this.sessionId,
        geoLat,
        geoLong,
        clientId: this.clientId,
      });
      const response = await fetch(`${config.API_URL}/signal`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionDescription: offer,
          sessionId: this.sessionId,
          source: source,
          clientId: this.clientId,
          context: {
            user_agent: userAgent,
            phone: phone,
            browser: browser,
            session_metadata: {
              camList: this.stream?.getVideoTracks()[0]?.getCapabilities(),
              device_details: enhancedDeviceDetails,
              devicePixelRatio: window.devicePixelRatio,
              geo_address: {
                geo_lat: geoLat,
                geo_long: geoLong,
                geo_source: geoSource,
              },
            },
            appType: isDemo ? 'demo' : 'primary',
            app_id: 1,
            bandwidth: this.bandwidthResults?.speedMbps || 5,
          }
        }),
      })
      const answer = await response.json()
      console.log('Received answer from server:', answer)
      this.posthogEvent.sendPostHogEvent('webrtc_connection_signal_success', {
        sessionId: this.sessionId,
      });
      // Check for iOS and handle state specially
      const isiOS = /iPhone|iPad|iPod/.test(userAgent);
      const isiOSPro = isiOS && /iPhone1[345]/.test(userAgent); // iOS Pro device detection

      // Log current state for debugging
      console.log(`Current signaling state before setting remote description: ${peerConnection.signalingState}`);

      // Handle state-based logic for setting remote description
      if (peerConnection.signalingState === 'have-local-offer') {
        // This is the normal expected state - proceed with setting remote description
        console.log('Setting remote description in have-local-offer state...');
        await peerConnection.setRemoteDescription(new RTCSessionDescription(answer));
        this.posthogEvent.sendPostHogEvent('webrtc_connection_remote_description_set', {
          sessionId: this.sessionId,
        });
      } else if (peerConnection.signalingState === 'stable' && isiOSPro) {
        // Special handling for iOS Pro devices in stable state
        console.log('iOS Pro device detected in stable state - creating new offer before setting remote');

        // Create a new offer to transition from stable state
        const newOffer = await peerConnection.createOffer({
          offerToReceiveVideo: true,
          offerToReceiveAudio: false,
        });

        // Set local description to transition from stable to have-local-offer
        await peerConnection.setLocalDescription(newOffer);

        // Wait for state transition
        await new Promise(resolve => {
          const checkState = () => {
            if (peerConnection.signalingState === 'have-local-offer') {
              peerConnection.removeEventListener('signalingstatechange', checkState);
              resolve(null);
            }
          };
          peerConnection.addEventListener('signalingstatechange', checkState);
          // Safety timeout
          setTimeout(resolve, 1000);
        });

        // Now set the remote description
        if (peerConnection.signalingState === 'have-local-offer') {
          console.log('Now in correct state, setting remote description');
          await peerConnection.setRemoteDescription(new RTCSessionDescription(answer));
        } else {
          console.warn(`Still in incorrect state: ${peerConnection.signalingState}, attempting to set remote anyway`);
          try {
            // Last resort attempt
            await peerConnection.setRemoteDescription(new RTCSessionDescription(answer));
          } catch (e) {
            webLogger.error('Final attempt to set remote description failed', e);
            console.error('Final attempt to set remote description failed:', e);
            // Initiate recovery procedure
            this.attemptConnectionRecovery();
          }
        }
      } else {
        console.error('Peer connection is not in the expected state:', peerConnection.signalingState);
        // Try anyway as a last resort
        try {
          await peerConnection.setRemoteDescription(new RTCSessionDescription(answer));
        } catch (err) {
          this.posthogEvent.sendPostHogEvent('webrtc_connection_remote_description_failed', {
            sessionId: this.sessionId,
            error: err,
          });
          webLogger.error('Failed to set remote description', err);
          console.error('Failed to set remote description due to state:', err);
          // Initiate full connection restart
          setTimeout(() => this.restartFullConnection(), 1000);
          return;
        }
      }

      const sender = peerConnection.getSenders().find((s) => s.track?.kind === 'video')

      if (sender) {
        const params = sender.getParameters()

        // Ensure `encodings` exists before modifying
        if (!params.encodings || params.encodings.length === 0) {
          params.encodings = [{}] // Initialize if empty
        }

        // Modify the first encoding safely
        Object.assign(params.encodings[0], {
          active: true,
          maxBitrate: 5000000,
          scaleResolutionDownBy: 1.0,
          maxFramerate: 10,
          priority: 'high',
        })

        try {
          await sender.setParameters(params)
          console.log('Successfully updated RTCRtpSender parameters!')
          this.posthogEvent.sendPostHogEvent('webrtc_connection_set_sender_parameters_sucess', {
            sessionId: this.sessionId,
          });
        } catch (e) {
          this.posthogEvent.sendPostHogEvent('webrtc_connection_set_sender_parameters_failed', {
            sessionId: this.sessionId,
            error: e,
          });
          webLogger.error('Failed to set RTCRtpSender parameters:', e);
          console.error('Failed to set parameters:', e)
        }
      }
    } catch (error) {
      this.posthogEvent.sendPostHogEvent('webrtc_connection_signal_establishment_failed', {
        sessionId: this.sessionId,
        error: error,
      });
      webLogger.error('Error in sendBifrostSignal', error);
      console.error('Error in sendBifrostSignal:', error);
      // Attempt recovery if signal exchange fails
      //this.attemptConnectionRecovery();
    }
  }

  // Add this new method to detect network connection type
  private getNetworkConnectionType(): string {
    // Use the Navigator Connection API if available
    const connection = (navigator as any).connection ||
      (navigator as any).mozConnection ||
      (navigator as any).webkitConnection;

    if (connection) {
      if (connection.effectiveType) {
        return connection.effectiveType; // '4g', '3g', '2g', or 'slow-2g'
      }

      // Fallback to checking downlink speed if effectiveType isn't available
      if (connection.downlink !== undefined) {
        if (connection.downlink < 0.5) return 'slow-3g';
        if (connection.downlink < 1.5) return '3g';
        return '4g';
      }
    }

    // Default to unknown if the API isn't available
    return 'unknown';
  }

  // Add this new method to show the low bandwidth popup
  private showLowBandwidthPopup(): void {
    console.log('Showing low bandwidth popup');

    // Create popup container (backdrop)
    const popup = document.createElement('div');
    popup.style.position = 'fixed';
    popup.style.top = '0';
    popup.style.left = '0';
    popup.style.width = '100%';
    popup.style.height = '100%';
    popup.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    popup.style.display = 'flex';
    popup.style.justifyContent = 'center';
    popup.style.alignItems = 'center';
    popup.style.zIndex = '9999';

    // Create popup content (modal)
    const popupContent = document.createElement('div');
    popupContent.style.backgroundColor = 'white';
    popupContent.style.borderRadius = '10px';
    popupContent.style.padding = '25px 25px 15px 25px';
    popupContent.style.maxWidth = '90%';
    popupContent.style.width = '360px';
    popupContent.style.boxShadow = '0 4px 24px rgba(0, 0, 0, 0.15)';
    popupContent.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

    // Create title
    const title = document.createElement('div');
    title.textContent = this.languageConfig.poorInternetTitle;
    title.style.margin = '0 0 16px 0';
    title.style.color = '#1a1a1a';
    title.style.fontSize = '20px';
    title.style.textAlign = 'left';

    // Create message
    const message = document.createElement('p');
    message.textContent = this.languageConfig.poorInternetDescription;
    message.style.margin = '0 0 32px 0';
    message.style.color = '#6b7280';
    message.style.fontSize = '16px';
    message.style.lineHeight = '1.5';
    message.style.textAlign = 'left';

    // Create button container
    const buttonContainer = document.createElement('div');
    buttonContainer.style.display = 'flex';
    buttonContainer.style.justifyContent = 'flex-end';
    buttonContainer.style.gap = '12px';

    // // Create CANCEL button
    // const cancelButton = document.createElement('button');
    // cancelButton.textContent = 'CANCEL';
    // cancelButton.style.background = 'none';
    // cancelButton.style.border = 'none';
    // cancelButton.style.color = '#6366f1';
    // cancelButton.style.fontSize = '14px';
    // cancelButton.style.fontWeight = '600';
    // cancelButton.style.letterSpacing = '0.5px';
    // cancelButton.style.cursor = 'pointer';
    // cancelButton.style.padding = '8px 16px';
    // cancelButton.style.borderRadius = '6px';
    // cancelButton.style.transition = 'background-color 0.2s';

    // Create TRY AGAIN button
    const tryAgainButton = document.createElement('button');
    tryAgainButton.textContent = this.languageConfig.tryAgain;
    tryAgainButton.style.background = 'none';
    tryAgainButton.style.border = 'none';
    tryAgainButton.style.color = '#6366f1';
    tryAgainButton.style.fontSize = '14px';
    tryAgainButton.style.fontWeight = '600';
    tryAgainButton.style.letterSpacing = '0.5px';
    tryAgainButton.style.cursor = 'pointer';
    tryAgainButton.style.padding = '8px 16px';
    tryAgainButton.style.borderRadius = '6px';
    tryAgainButton.style.transition = 'background-color 0.2s';

    // // Add hover effects
    // cancelButton.addEventListener('mouseenter', () => {
    //   cancelButton.style.backgroundColor = 'rgba(99, 102, 241, 0.08)';
    // });
    // cancelButton.addEventListener('mouseleave', () => {
    //   cancelButton.style.backgroundColor = 'transparent';
    // });

    tryAgainButton.addEventListener('mouseenter', () => {
      tryAgainButton.style.backgroundColor = 'rgba(99, 102, 241, 0.08)';
    });
    tryAgainButton.addEventListener('mouseleave', () => {
      tryAgainButton.style.backgroundColor = 'transparent';
    });

    // Add click handlers
    // cancelButton.addEventListener('click', () => {
    //   // Log cancel event
    //   this.posthogEvent?.sendPostHogEvent('low_bandwidth_popup_action', {
    //     action: 'cancel',
    //     bandwidth: this.bandwidthResults?.speedMbps || 0,
    //     connectionType: this.getNetworkConnectionType(),
    //     sessionId: this.sessionId
    //   });

    //   // Remove popup
    //   document.body.removeChild(popup);

    //   // You might want to handle cancel action here (e.g., stop verification)
    //   // this.stopVerification();
    // });

    tryAgainButton.addEventListener('click', () => {
      // Log try again event
      this.posthogEvent?.sendPostHogEvent('low_bandwidth_popup_action', {
        action: 'try_again',
        bandwidth: this.bandwidthResults?.speedMbps || 0,
        connectionType: this.getNetworkConnectionType(),
        sessionId: this.sessionId
      });

      // Remove popup
      //document.body.removeChild(popup);
      window.location.reload();

      // Retry the action that triggered the popup
      // You might want to retry verification or connection test here
      // this.retryVerification();
    });

    // Assemble the modal
    //buttonContainer.appendChild(cancelButton);
    buttonContainer.appendChild(tryAgainButton);
    popupContent.appendChild(title);
    popupContent.appendChild(message);
    popupContent.appendChild(buttonContainer);
    popup.appendChild(popupContent);

    // Add popup to body
    document.body.appendChild(popup);

    // Close on backdrop click
    popup.addEventListener('click', (e) => {
      if (e.target === popup) {
        this.posthogEvent?.sendPostHogEvent('low_bandwidth_popup_action', {
          action: 'backdrop_click',
          bandwidth: this.bandwidthResults?.speedMbps || 0,
          connectionType: this.getNetworkConnectionType(),
          sessionId: this.sessionId
        });
        document.body.removeChild(popup);
      }
    });

    // Log initial event
    this.posthogEvent?.sendPostHogEvent('low_bandwidth_detected', {
      result: 'warning',
      bandwidth: this.bandwidthResults?.speedMbps || 0,
      connectionType: this.getNetworkConnectionType(),
      sessionId: this.sessionId
    });
  }
  private initializeMQTT(): void {
    console.log('InitializeMQTT')
    const currentUrl = window.location.href
    const urlObj = new URL(currentUrl)
    const isDemo = urlObj.searchParams.get('isDemo');
    const showSessionId = urlObj.searchParams.get('showSessionId'); // Add this line
    this.sessionId = crypto.randomUUID();
    // Only create session ID display if showSessionId=true is in URL
    if (showSessionId === 'true') {
      setTimeout(() => {
        this.createSessionIdDisplay();
      }, 5000);
    }

    const genuineCount = 1;
    const maxRejectCount = this.productConfigId && (this.productConfigId.toLowerCase().includes('cnhi') || this.productConfigId.toLowerCase().includes('hul')) ? 9 : 2;
    const fakeCount = maxRejectCount + 1;
    try {
      localStorage.setItem('sessionId', this.sessionId)
    } catch (err) {
      console.log('Error in setting local storage')
    }
    const MQTT_TEMP_CONFIG = this.environment && (this.environment.toUpperCase() === 'PROD' || this.environment.toUpperCase() === 'STAGE') ? MQTT_PROD_CONFIG : MQTT_QA_CONFIG;
    // const MQTT_TEMP_CONFIG = isProd ?  MQTT_PROD_CONFIG : MQTT_CONFIG;
    this.mqttClient = mqtt.connect(MQTT_TEMP_CONFIG.url, {
      username: MQTT_TEMP_CONFIG.username,
      password: MQTT_TEMP_CONFIG.password,
      clean: true,
      clientId: this.sessionId,
      rejectUnauthorized: false,
    })
    this.mqttClient.on('error', (err) => {
      this.posthogEvent?.sendPostHogEvent('mqtt_connection_failed', {
        error: err.message,
        sessionId: this.sessionId
      });
      console.error('MQTT Connection Error:', err.message)
    })
    this.mqttSessionExpireTopic = `${this.sessionId}-image-stream/session-close`
    this.mqttClient.on('connect', (conn) => {
      console.log('Connected to MQTT Broker', conn.sessionPresent)
      this.posthogEvent?.sendPostHogEvent('mqtt_connection_established', {
        sessionId: this.sessionId,
        isSessionPresent: conn.sessionPresent,
      });
      this.mqttClient?.subscribe(`${this.sessionId}-image-stream/results`, (err) => {
        if (!err) {
          console.log('Subscribed to image-stream/results')
        } else {
          console.error('Failed to subscribe to topic:', err)
        }
      })
      console.log(`Connected to ${this.sessionId}-image-stream/results`)
    })

    let triggerCalled = false
    let tenSecondTriggerCalled = false

    const triggerFunction = () => {
      if (triggerCalled) {
        return
      }
      this.showRestart = true
      triggerCalled = true
      this.posthogEvent.sendPostHogEvent('timeout', {
        result: 'success',
        sessionId: this.sessionId,
        reason: 'timeout',
        text: this.languageConfig.productNotInFocus,
        verificationSessionId: this.legacySessionId
      });
      this.sendSessionResult('PHOTO_QUALITY_ISSUE', 4, 'PRODUCT_NOT_IN_FOCUS', genuineCount, fakeCount, this.sessionId)
      this.stop()
    }

    const tenSecondTriggerFunction = () => {
      if (tenSecondTriggerCalled) {
        return
      }
      tenSecondTriggerCalled = true
      this.createToast(this.languageConfig.keepProductCentered, '#242424', '#FFFFFF', '')
      this.posthogEvent.sendPostHogEvent('object_detection_unsuccessful', {
        result: 'success',
        sessionId: this.sessionId,
        reason: 'ten_second_timeout',
        text: this.languageConfig.keepProductCentered,
        verificationSessionId: this.legacySessionId
      })
    }

    // Debounce utility function
    const debounce = (func: (...args: any[]) => void, delay: number) => {
      let timeoutId: NodeJS.Timeout | null = null
      return (...args: any[]) => {
        if (timeoutId) {
          clearTimeout(timeoutId)
        }
        timeoutId = setTimeout(() => {
          func(...args)
          timeoutId = null
        }, delay)
      }
    }

    // Create a debounced version of sendImages with 100ms delay
    //const debouncedSendImages = debounce(() => this.sendImages(), 10);

    // Track productConfigId counts
    const productConfigIdCounts: Map<string, number> = new Map()
    let countOfDetects = 0;
    this.messageHandler = (topic, message) => {
      console.log(`Received message on topic ${topic}: ${message.toString()}`)
      if (!this.resultsShown) {
        const detection: Detection = JSON.parse(message.toString())
        countOfDetects = countOfDetects + 1;
        console.log('Detection ::', detection, countOfDetects);
        if (detection.sessionId === this.sessionId) {
          const currentUrl = window.location.href
          const urlObj = new URL(currentUrl)
          const secondParam = urlObj.searchParams.get('second')

          // Check if detection has either prediction or coords
          if (detection.prediction || (detection.coords && detection.coords.length)) {
            if (this.detectionTimeout) {
              clearTimeout(this.detectionTimeout)
              this.detectionTimeout = ''
            }
            if (this.tenSecondTimeout) {
              clearTimeout(this.tenSecondTimeout)
              tenSecondTriggerCalled = false
              this.tenSecondTimeout = ''
            }
          }
          if (!this.detectionTimeout) {
            this.detectionTimeout = setTimeout(triggerFunction, 15000)
          }
          if (this.startTime) {
            const elapsedTime = (Date.now() - this.startTime) / 1000
            const timeLimit = secondParam ? parseInt(secondParam, 10) : null
            if (!this.resultsShown && timeLimit && elapsedTime > timeLimit) {
              this.handleDetectionLabel('reject')
              this.startTime = null
            }
          }
          if (
            detection &&
            detection.prediction_result !== null &&
            typeof detection.prediction_result !== 'undefined' &&
            [0, 1, -1].includes(detection.prediction_result) &&  detection.decoderConfigId === this.decoderConfigId
          ) {
            const label =
              detection?.prediction_result === 0
                ? 'accept'
                : detection?.prediction_result === 1
                  ? 'reject'
                  : detection?.prediction_result === -1
                    ? 'cannot_confirm'
                    : ''
            if (label) {
              triggerCalled = false
              try {
                this.handleDetectionLabel(label, detection?.probability)
              } catch (err) {

                this.posthogEvent.sendPostHogEvent('verification_result_error', {
                  sessionId: this.sessionId,
                  err: err,
                });
              }
            }
          } else if (detection.coords && detection.coords.length && !this.resultsShown) {
            // Track the start time
            if ((secondParam || isDemo) && !this.startTime && this.flow === FLOW.VIDEO_STREAM) {
              this.startTime = Date.now()
              const currentUrl = window.location.href
              const urlObj = new URL(currentUrl)
              const showLogs = urlObj.searchParams.get('showLogs')
              if (showLogs) {
                this.createTimerDisplay()
              }
            }

            if (!this.stopProcessingDetects) {
              // Handle product identification with count tracking
              if (!this.isProductIdentified && (detection.label || this.flow === FLOW.VIDEO_STREAM)) {
                // Update the count for this productConfigId
                const currentCount = productConfigIdCounts.get(detection.label) || 0
                productConfigIdCounts.set(detection.label, currentCount + 1)
                if (!isDemo) {
                  // Only call showProductIdentification if count reaches 5
                  if (productConfigIdCounts.get(detection.label) === 5) {
                    this.showProductIdentification(detection.label, detection.decode_config_id)
                  }
                } else {
                  this.showProductIdentification('"Enno_coaster accept"');
                }
              } else if (this.isProductIdentified) {
                this.showProductVerification(detection.coords)
                // Call debounced sendImages for legacy flow
                if (this.flow === FLOW.IMAGE_STREAM && this.imageCount) {
                  if (!this.pollingInitiated) {
                    this.pollingInitiated = true
                    this.initiatePoll()
                  }
                  console.log('TriggerDebouncedImages')
                  if (this.legacyImageCount < this.imageCount) {
                    this.legacyImageCount = this.legacyImageCount + 1
                    this.sendImages()
                  }
                }
              }
            }
          } else {
            if (!this.tenSecondTimeout && !this.resultsShown) {
              this.tenSecondTimeout = setTimeout(tenSecondTriggerFunction, 10000)
            }
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
          }
        }
      }
    }

    this.mqttClient.on('message', this.messageHandler)
  }

  /* UI Code */x
  private stepOne() {
    this.drawGrid()
    setTimeout(() => {
      //this.createCornerOverlay()
      this.createCornerOverlayWithImage();
    }, 500)
  }
  private createPulsatingBubbles(rect) {
    const style = document.createElement('style')
    if (!document.head.querySelector('#bubble-styles')) {
      style.id = 'bubble-styles'
      style.innerHTML = `
          @keyframes pulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.4); opacity: 0.8; }
          }

          @keyframes ripple {
            0% { transform: scale(1); opacity: 1; }
            100% { transform: scale(2.5); opacity: 0; }
          }
        `
      document.head.appendChild(style)
    }

    const now = Date.now()
    const elapsedTime = now - this.lastCheckedTime

    // If rect is empty, remove all bubbles and reset
    if (!rect || Object.values(rect).some((v) => v === 0)) {
      this.currentBubbles.forEach((b) => b.element.remove())
      this.currentBubbles = []
      this.lastRect = null
      this.lastCheckedTime = now // Reset the timer if rect is empty
      return
    }

    // Check if rect has changed significantly
    const rectChanged =
      !this.lastRect ||
      Math.abs(rect.x - this.lastRect.x) > this.bubbleThresholdDistance ||
      Math.abs(rect.y - this.lastRect.y) > this.bubbleThresholdDistance ||
      Math.abs(rect.width - this.lastRect.width) > this.bubbleThresholdDistance ||
      Math.abs(rect.height - this.lastRect.height) > this.bubbleThresholdDistance

    // **MODIFICATION**: Draw bubbles if no bubbles currently exist, even if rect hasn't changed
    const noBubblesExist = this.currentBubbles.length === 0

    if (rectChanged || noBubblesExist) {
      if (!this.changeStartTime) {
        this.changeStartTime = now // Start timing when the change is first detected
      }

      // If the change has persisted for more than 1 second, redraw
      if (elapsedTime > 1000) {
        this.lastRect = { ...rect } // Update the stored rect
        this.changeStartTime = null // Reset the timer after redrawing
        this.lastCheckedTime = now // Reset the last check time

        // Remove old bubbles and generate new ones
        this.currentBubbles.forEach((b) => b.element.remove())
        this.currentBubbles = []

        const area = rect.width * rect.height
        const bubbleCount = Math.max(
          this.minBubbles,
          Math.min(this.maxBubbles, Math.floor(area / 5000)),
        )

        const minDistance = 22 // Prevent overlap

        for (let i = 0; i < bubbleCount; i++) {
          let x, y, overlapping

          do {
            x = rect.x + Math.random() * rect.width
            y = rect.y + Math.random() * rect.height
            overlapping = this.currentBubbles.some(
              (b) => Math.hypot(b.x - x, b.y - y) < minDistance,
            )
          } while (overlapping)

          const bubbleContainer = document.createElement('div')
          bubbleContainer.classList.add('pulsating-bubble')
          bubbleContainer.style.position = 'absolute'
          bubbleContainer.style.left = `${x}px`
          bubbleContainer.style.top = `${y}px`
          bubbleContainer.style.width = '16px'
          bubbleContainer.style.height = '16px'
          bubbleContainer.style.zIndex = '9999'

          const innerSize = Math.random() > 0.5 ? '3px' : '5px'

          const innerBubble = document.createElement('div')
          innerBubble.style.width = innerSize
          innerBubble.style.height = innerSize
          innerBubble.style.background = 'white'
          innerBubble.style.borderRadius = '50%'
          innerBubble.style.position = 'absolute'
          innerBubble.style.top = '50%'
          innerBubble.style.left = '50%'
          innerBubble.style.transform = 'translate(-50%, -50%)'
          innerBubble.style.animation = 'pulse 1.5s infinite ease-in-out'

          const ripple = document.createElement('div')
          ripple.style.width = innerSize
          ripple.style.height = innerSize
          ripple.style.border = '2px solid white'
          ripple.style.borderRadius = '50%'
          ripple.style.position = 'absolute'
          ripple.style.top = '50%'
          ripple.style.left = '50%'
          ripple.style.transform = 'translate(-50%, -50%) scale(1)'
          ripple.style.animation = 'ripple 1.5s infinite ease-out'

          bubbleContainer.appendChild(innerBubble)
          bubbleContainer.appendChild(ripple)
          if( this.overlay){
            this.overlay.appendChild(bubbleContainer)
          }

          this.currentBubbles.push({ x, y, element: bubbleContainer })
        }
      }
    } else {
      // If rect hasn't changed, reset the change timer
      this.changeStartTime = null
    }

    // Keep bubbles alive by resetting the removal timer every second
    clearTimeout(this.bubbleRemovalTimer)
    this.bubbleRemovalTimer = setTimeout(() => {
      this.currentBubbles.forEach((b) => b.element.remove())
      this.currentBubbles = []
    }, 1100) // Slightly more than 1 second to prevent flickering
  }
  private createOverlay() {
    // Check if an overlay with the given ID already exists
    if (document.getElementById('custom-overlay')) {
      console.log('Overlay already exists.')
      return // Exit the function if the overlay already exists
    }

    // Create the overlay
    this.overlay = document.createElement('div')
    this.overlay.id = 'custom-overlay' // Assign a unique ID for identification
    this.overlay.style.position = 'absolute'
    this.overlay.style.top = '0'
    this.overlay.style.left = '0'
    this.overlay.style.width = '100vw'
    this.overlay.style.height = '100vh'
    this.overlay.style.background = 'rgba(0, 0, 0, 0.3)' // Slightly dark overlay
    this.overlay.style.zIndex = '10'

    // Add the overlay to the body
    document.body.appendChild(this.overlay)
  }
  private clearOverlay(): Promise<void> {
    return new Promise((resolve) => {
      if (this.overlay) {
        // Remove all child elements from the overlay
        while (this.overlay.firstChild) {
          this.overlay.removeChild(this.overlay.firstChild)
        }
        console.log('Overlay cleared successfully.')
      } else {
        console.log('Overlay not found.')
      }
      this.removeTopRightText()
      this.hideBlackToast()
      this.hideBouncingArrow()
      this.removeAllToasts()
      this.removeCornerOverlay()
      this.removeViewfinderBorder()
      this.clearResultContainer();
      // Add a short delay to ensure all rendering updates are processed
      setTimeout(() => {
        resolve()
      }, 100) // 100ms delay to ensure any pending operations complete
    })
  }
  private calculateGridRowHeight() {
    // Get the grid container by its ID
    const gridContainer = document.getElementById('grid-container')

    // Check if the gridContainer exists before proceeding
    if (!gridContainer) {
      console.error('Grid container not found.')
      return
    }

    // Calculate the height of each row
    const gridRowHeight = gridContainer.offsetHeight / 3 // Assuming 3 rows
    console.log(`Height of each row: ${gridRowHeight}px`)
    return gridRowHeight
  }
  private createCornerOverlay(width = 200, height = 150) {
    // Check if an overlay with the given ID already exists
    if (document.getElementById('corner-overlay')) {
      console.log('Corner overlay already exists.')
      return // Exit the function if the overlay already exists
    }
    let calculatedHeight = this.calculateGridRowHeight()
    calculatedHeight = calculatedHeight + 80
    // Create a container for the overlay
    const overlay = document.createElement('div')
    overlay.id = 'corner-overlay'
    overlay.style.position = 'absolute'
    overlay.style.top = `${calculatedHeight + 40}px`
    overlay.style.left = '50%'
    overlay.style.width = '90%'
    overlay.style.height = '360px'
    overlay.style.transform = 'translate(-50%, -50%)'
    overlay.style.zIndex = '10'
    overlay.style.pointerEvents = 'none' // Make sure the overlay doesn't block clicks

    // Create a function to add a corner
    function createCorner(position) {
      const corner = document.createElement('div')
      corner.style.position = 'absolute'
      corner.style.width = '40px' // Corner width
      corner.style.height = '40px' // Corner height
      corner.style.border = '4px solid white'

      // Position each corner based on the provided position
      if (position === 'top-left') {
        corner.style.top = '0'
        corner.style.left = '0'
        corner.style.borderRight = 'none'
        corner.style.borderBottom = 'none'
      } else if (position === 'top-right') {
        corner.style.top = '0'
        corner.style.right = '0'
        corner.style.borderLeft = 'none'
        corner.style.borderBottom = 'none'
      } else if (position === 'bottom-left') {
        corner.style.bottom = '0'
        corner.style.left = '0'
        corner.style.borderRight = 'none'
        corner.style.borderTop = 'none'
      } else if (position === 'bottom-right') {
        corner.style.bottom = '0'
        corner.style.right = '0'
        corner.style.borderLeft = 'none'
        corner.style.borderTop = 'none'
      }

      return corner
    }

    // Add corners to the overlay
    overlay.appendChild(createCorner('top-left'))
    overlay.appendChild(createCorner('top-right'))
    overlay.appendChild(createCorner('bottom-left'))
    overlay.appendChild(createCorner('bottom-right'))

    // Add the overlay to the body
    document.body.appendChild(overlay)
  }

  private createCornerOverlayWithImage() {
    const currentUrl = window.location.href
    const urlObj = new URL(currentUrl)
    const client = urlObj.searchParams.get('client');
    const uId = this.clientId;
    const clientIdMappings = this.appConfig?.clientIdMappings || {};
    // Check if an overlay with the given ID already exists
    if (document.getElementById('corner-overlay')) {
      console.log('Corner overlay already exists.')
      return // Exit the function if the overlay already exists
    }

    let calculatedHeight = this.calculateGridRowHeight()
    calculatedHeight = calculatedHeight + 80

    // Create a container for the overlay
    const overlay = document.createElement('div')
    overlay.id = 'corner-overlay'
    overlay.style.position = 'absolute'
    overlay.style.top = `${calculatedHeight + 40}px`
    overlay.style.left = '50%'
    overlay.style.width = '90%'
    overlay.style.height = '360px'
    overlay.style.transform = 'translate(-50%, -50%)'
    overlay.style.zIndex = '10'
    overlay.style.pointerEvents = 'none' // Make sure the overlay doesn't block clicks
    overlay.style.display = 'flex'
    overlay.style.alignItems = 'center'
    overlay.style.justifyContent = 'center'

    // Create the image element
    const image = document.createElement('img')

    // Function to check if device is iOS (matching the logic from the document)
    const checkIfIOS = () => {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    }

    // Function to calculate overlay dimensions based on the logic from the document
    const calculateOverlayDimensions = (client: string, uId: string) => {
      // Default values based on client
      let actualLabelWidth: number;
      const overlayConfig: any = {};
      if (client === 'cnh' || clientIdMappings[uId] === 'CNH') {
        actualLabelWidth = 100; // Base width for CNH
        overlayConfig.ios = 6; // Reference width for iOS
        overlayConfig.android = 8; // Reference width for Android
      } else if (client === 'hul' || clientIdMappings[uId] === 'HUL') {
        actualLabelWidth = 280; // Base width for HUL
        overlayConfig.ios = 9;
        overlayConfig.android = 11;
      } else {
        // Default values
        actualLabelWidth = 200;
        overlayConfig.ios = 9;
        overlayConfig.android = 11;
      }

      // Get viewport width
      const viewFinderWidth = window.innerWidth;

      // Calculate reference width based on platform (matching document logic)
      const referenceWidthInViewFinder = checkIfIOS()
        ? (overlayConfig.ios || 11)
        : (overlayConfig.android || 11);

      // Calculate overlay width using the same formula from the document
      const overlayWidth = (actualLabelWidth * viewFinderWidth) / referenceWidthInViewFinder;

      // Apply additional factor for iOS devices
      let factor = checkIfIOS() ? 0.6 : 1;

      // Check for specific model adjustments
      const userAgent = navigator.userAgent;
      if (userAgent.includes('SM-A325F')) {
        factor = 1.55;
      }

      // Calculate final dimensions
      const finalWidth = overlayWidth * factor;

      // Set max constraints (from the document's default properties)
      const OVERLAY_MAX_HEIGHT = '200px';
      const OVERLAY_MAX_WIDTH = '200px';

      return {
        width: finalWidth,
        maxWidth: OVERLAY_MAX_WIDTH,
        maxHeight: OVERLAY_MAX_HEIGHT,
        factor: factor
      };
    }

    // Calculate dimensions based on client
    const dimensions = calculateOverlayDimensions(client || '', uId || '');

    // Apply styles to image based on client and calculated dimensions
    if (client === 'cnh' || clientIdMappings[uId || ''] === 'CNH') {
      image.style.position = 'absolute';
      image.style.top = '10px';
      image.style.width = '150px';
      image.style.maxWidth = checkIfIOS() ? '80px' : '100px';
      image.style.maxHeight = dimensions.maxHeight;
      image.src = CNH_OVERLAY;
    } else if (client === 'hul' || clientIdMappings[uId || ''] === 'HUL') {
      //image.style.position = 'absolute';
      //image.style.top = '10px';
      image.style.width = `${dimensions.width}px`;
      image.style.maxWidth = checkIfIOS() ? '200px' : '240px';
      image.style.maxHeight = dimensions.maxHeight;
      image.src = HUL_OVERLAY;
    } else if (clientIdMappings[uId || ''] === 'NESTLE') {
      // image.style.position = 'absolute';
      // image.style.top = '33px';
      image.style.width = `${dimensions.width}px`;
      image.style.maxWidth = checkIfIOS() ? '230px' : '260px';
      image.style.maxHeight = dimensions.maxHeight;
      image.src = NESTLE_OVERLAY;
    } else if (clientIdMappings[uId || ''] === 'GODREJ') {
      // image.style.position = 'absolute';
      // image.style.top = '33px';
      image.style.width = `${dimensions.width}px`;
      image.style.maxWidth = checkIfIOS() ? '230px' : '260px';
      image.style.maxHeight = dimensions.maxHeight;
      image.src = GOODKNIGHT_OVERLAY;
    } else if (clientIdMappings[uId || ''] === 'DENSO') {
      // image.style.position = 'absolute';
      // image.style.top = '33px';
      image.style.width = `${dimensions.width}px`;
      image.style.maxWidth = checkIfIOS() ? '200px' : '240px';
      image.style.maxHeight = dimensions.maxHeight;
      image.src = IRIDIUM_OVERLAY;
    } 

    image.style.height = 'auto';
    image.style.objectFit = 'contain';
    image.style.display = 'block';
    image.alt = 'overlay'; // Matching OVERLAY_ALT from the document

    // Add error handling for image loading
    image.onerror = (e: any) => {
      console.error('Failed to load overlay image:', image.src);
      // You could set a default overlay image here if you have one
      // if (e.currentTarget instanceof HTMLImageElement) {
      //   e.currentTarget.src = DEFAULT_OVERLAY_IMG;
      // }
    }

    image.onload = () => {
      console.log('Overlay image loaded successfully')
    }

    // Create a function to add a corner
    function createCorner(position: string) {
      const corner = document.createElement('div')
      corner.style.position = 'absolute'

      // Make corners responsive based on viewport and iOS detection
      const isSmallDevice = window.innerWidth <= 480;
      const isIOS = checkIfIOS();

      let cornerSize = '40px';
      let borderWidth = '4px';

      if (isSmallDevice || isIOS) {
        cornerSize = '30px';
        borderWidth = '3px';
      }

      corner.style.width = cornerSize;
      corner.style.height = cornerSize;
      corner.style.border = `${borderWidth} solid white`;
      corner.style.zIndex = '1'; // Ensure corners appear above the image

      // Position each corner based on the provided position
      if (position === 'top-left') {
        corner.style.top = '0'
        corner.style.left = '0'
        corner.style.borderRight = 'none'
        corner.style.borderBottom = 'none'
      } else if (position === 'top-right') {
        corner.style.top = '0'
        corner.style.right = '0'
        corner.style.borderLeft = 'none'
        corner.style.borderBottom = 'none'
      } else if (position === 'bottom-left') {
        corner.style.bottom = '0'
        corner.style.left = '0'
        corner.style.borderRight = 'none'
        corner.style.borderTop = 'none'
      } else if (position === 'bottom-right') {
        corner.style.bottom = '0'
        corner.style.right = '0'
        corner.style.borderLeft = 'none'
        corner.style.borderTop = 'none'
      }

      return corner
    }

    
    if (['CNH', 'HUL', 'NESTLE', 'GODREJ', 'DENSO'].includes(clientIdMappings[uId || ''])) {
      overlay.appendChild(image)
    }

    // Add corners to the overlay
    overlay.appendChild(createCorner('top-left'))
    overlay.appendChild(createCorner('top-right'))
    overlay.appendChild(createCorner('bottom-left'))
    overlay.appendChild(createCorner('bottom-right'))

    // Add the overlay to the body
    document.body.appendChild(overlay)

    // Optional: Add resize listener to update dimensions on orientation change
    const handleResize = () => {
      const newDimensions = calculateOverlayDimensions(client || '', uId || '');

      image.style.width = `${newDimensions.width}px`;
      image.style.maxWidth = newDimensions.maxWidth;
      image.style.maxHeight = newDimensions.maxHeight;

      // Update corner sizes
      const corners = overlay.querySelectorAll('div');
      const isSmallDevice = window.innerWidth <= 480;
      const isIOS = checkIfIOS();

      let cornerSize = '40px';
      let borderWidth = '4px';

      if (isSmallDevice || isIOS) {
        cornerSize = '30px';
        borderWidth = '3px';
      }

      corners.forEach((corner, index) => {
        if (index > 0) { // Skip the first div (which is the overlay itself)
          corner.style.width = cornerSize;
          corner.style.height = cornerSize;
          corner.style.borderWidth = borderWidth;
        }
      });
    }

    // Add resize listener (with debouncing for performance)
    let resizeTimeout: any;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 150);
    });
  }

  private removeCornerOverlay() {
    // Get the overlay element by its ID
    const overlay = document.getElementById('corner-overlay')

    // Check if the overlay exists before attempting to remove it
    if (overlay) {
      // Remove the overlay from the DOM
      overlay.remove()
      console.log('Corner overlay removed.')
    } else {
      console.log('Corner overlay not found.')
    }
  }
  private createToast(text = '', background = '', color = '', icon = '') {
    // Remove existing toast if it exists
    const existingToast = document.querySelector('.toast-message')
    if (existingToast) {
      existingToast.remove()
    }

    this.toast = document.createElement('div')
    this.toast.classList.add('toast-message')
    this.toast.style.position = 'absolute'
    this.toast.style.top = '30px'
    this.toast.style.left = '50%'
    this.toast.style.transform = 'translateX(-50%)'
    this.toast.style.background = background
    this.toast.style.color = color
    this.toast.style.padding = '12px 16px'
    this.toast.style.fontSize = '13px'
    this.toast.style.borderRadius = '10px'
    this.toast.style.zIndex = '11'
    this.toast.style.width = '90%'
    this.toast.style.fontFamily = 'Open Sans'
    this.toast.style.fontWeight = 'bold'
    this.toast.style.textAlign = 'center'
    this.toast.style.display = 'flex'
    this.toast.style.alignItems = 'center'
    this.toast.style.justifyContent = 'center'
    this.toast.style.gap = '8px' // Space between text and icon

    // Create text span
    const textSpan = document.createElement('span')
    textSpan.innerText = text

    // Create icon element if icon path is provided
    if (icon) {
      const iconImg = document.createElement('img')
      iconImg.src = icon
      iconImg.style.width = '18px' // Adjust size as needed
      iconImg.style.height = '18px'
      iconImg.style.display = 'inline-block'

      this.toast.appendChild(textSpan)
      this.toast.appendChild(iconImg) // Append icon to the right
    } else {
      this.toast.appendChild(textSpan)
    }

    this.overlay.appendChild(this.toast)
  }

  private createSessionIdDisplay(): void {
    // Remove existing session ID display if it exists
    const existingDisplay = document.querySelector('.session-id-display');
    if (existingDisplay) {
      existingDisplay.remove();
    }

    // Create the session ID container
    const sessionIdContainer = document.createElement('div');
    sessionIdContainer.classList.add('session-id-display');
    sessionIdContainer.style.position = 'fixed';
    sessionIdContainer.style.bottom = '160px';
    sessionIdContainer.style.left = '50%';
    sessionIdContainer.style.transform = 'translateX(-50%)';
    sessionIdContainer.style.background = '#242424';
    sessionIdContainer.style.color = '#FFFFFF';
    sessionIdContainer.style.padding = '10px 20px';
    sessionIdContainer.style.fontSize = '14px';
    sessionIdContainer.style.borderRadius = '8px';
    sessionIdContainer.style.zIndex = '10';
    sessionIdContainer.style.width = '100%';
    sessionIdContainer.style.fontFamily = 'Open Sans';
    sessionIdContainer.style.display = 'flex';
    sessionIdContainer.style.alignItems = 'center';
    sessionIdContainer.style.gap = '10px';
    sessionIdContainer.style.zIndex = '10000';
    sessionIdContainer.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.2)';

    // Create session ID text
    const sessionIdText = document.createElement('span');
    sessionIdText.innerText = `Session ID: ${this.sessionId}`;

    // Create copy button
    const copyButton = document.createElement('button');
    copyButton.innerText = 'Copy';
    copyButton.style.background = '#007bff';
    copyButton.style.color = '#FFFFFF';
    copyButton.style.border = 'none';
    copyButton.style.padding = '6px 12px';
    copyButton.style.borderRadius = '6px';
    copyButton.style.cursor = 'pointer';
    copyButton.style.fontSize = '13px';
    copyButton.style.fontFamily = 'Open Sans';

    // Add hover effect for better UX
    copyButton.addEventListener('mouseover', () => {
      copyButton.style.background = '#0056b3';
    });
    copyButton.addEventListener('mouseout', () => {
      copyButton.style.background = '#007bff';
    });

    // Copy to clipboard functionality
    copyButton.addEventListener('click', () => {
      navigator.clipboard.writeText(this.sessionId).then(() => {
        // Show confirmation toast
        this.createToast('Session ID copied to clipboard!', '#242424', '#FFFFFF', '');
        // Auto-hide toast after 3 seconds
        setTimeout(() => {
          const toast = document.querySelector('.toast-message');
          if (toast) {
            toast.remove();
          }
        }, 3000);
      }).catch((err) => {
        webLogger.error('Failed to copy session ID', err);
        console.error('Failed to copy session ID:', err);
        this.createToast('Failed to copy session ID', '#ff0000', '#FFFFFF', '');
      });
    });

    // Append elements to container
    sessionIdContainer.appendChild(sessionIdText);
    sessionIdContainer.appendChild(copyButton);

    // Append to the overlay or body
    this.overlay ? this.overlay.appendChild(sessionIdContainer) : document.body.appendChild(sessionIdContainer);
  }

  private removeAllToasts() {
    const toastMessages = document.querySelectorAll('div.toast-message')
    // Loop through and remove each element
    toastMessages.forEach((toast) => {
      toast.remove()
    })
  }
  private createDropdownMessage(image = '', text1 = '', text2 = '', background = '', color = '', backgroundImageColor = '') {
    // Create background overlay to darken the viewfinder
    const backgroundOverlay = document.createElement('div')
    backgroundOverlay.style.position = 'absolute'
    backgroundOverlay.style.top = '0'
    backgroundOverlay.style.left = '0'
    backgroundOverlay.style.width = '100%'
    backgroundOverlay.style.height = '100%'
    backgroundOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)' // Semi-transparent black
    backgroundOverlay.style.zIndex = '10' // Just below the message
    backgroundOverlay.style.opacity = '0'
    backgroundOverlay.style.transition = 'opacity 0.5s ease-out'
    this.overlay.appendChild(backgroundOverlay)

    const messageDiv = document.createElement('div')
    messageDiv.style.position = 'absolute'
    messageDiv.style.top = '20px' // Always positioned at 20px
    messageDiv.style.left = '50%'
    messageDiv.style.transform = 'translateX(-50%)'
    messageDiv.style.background = background
    messageDiv.style.color = color
    messageDiv.style.padding = '16px'
    messageDiv.style.fontSize = '14px'
    messageDiv.style.borderRadius = '10px'
    messageDiv.style.zIndex = '11'
    messageDiv.style.width = '90%'
    messageDiv.style.maxWidth = '320px'
    messageDiv.style.fontFamily = 'Open Sans'
    messageDiv.style.fontWeight = 'bold'
    messageDiv.style.textAlign = 'center'
    messageDiv.style.display = 'flex'
    messageDiv.style.flexDirection = 'column'
    messageDiv.style.alignItems = 'center'
    messageDiv.style.gap = '10px' // Space between elements
    messageDiv.style.boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.1)'
    messageDiv.style.opacity = '0'
    messageDiv.style.overflow = 'hidden' // Ensures smooth drop effect
    messageDiv.style.height = 'auto' // Required for max-height to work
    messageDiv.style.maxHeight = '20px' // Initially collapsed height
    messageDiv.style.transition = 'max-height 0.5s ease-out, opacity 0.5s ease-out'

    // Create image element if provided
    if (image) {
      const imgElement = document.createElement('img')
      imgElement.src = image
      imgElement.style.width = '50px' // Adjust size as needed
      imgElement.style.height = '50px'
      imgElement.style.borderRadius = '50%'
      imgElement.style.objectFit = 'cover'
      imgElement.style.background = backgroundImageColor ? backgroundImageColor : '';
      messageDiv.appendChild(imgElement)
    }

    // Create first text
    const textSpan1 = document.createElement('span')
    textSpan1.innerText = text1
    textSpan1.style.fontSize = '18px'
    textSpan1.style.fontWeight = '700'
    textSpan1.style.fontFamily = 'Open Sans'
    messageDiv.appendChild(textSpan1)

    // Create second text
    const textSpan2 = document.createElement('span')
    textSpan2.innerText = text2
    textSpan2.style.fontSize = '12px'
    textSpan2.style.fontWeight = '600'
    textSpan2.style.fontFamily = 'Open Sans'
    messageDiv.appendChild(textSpan2)

    this.overlay.appendChild(messageDiv)

    // Store references to both elements for cleanup later if needed
    this.currentDropdownElements = {
      messageDiv,
      backgroundOverlay
    }

    // Trigger the dropdown curtain effect and background overlay after a slight delay
    setTimeout(() => {
      messageDiv.style.opacity = '1'
      messageDiv.style.maxHeight = '500px' // Expand smoothly like a curtain
      backgroundOverlay.style.opacity = '1' // Fade in the background overlay
    }, 50)
  }
  private highlightViewfinderBorder(color = '') {
    if (document.getElementById('viewfinder-border')) return
    const borderDiv = document.createElement('div')
    borderDiv.id = 'viewfinder-border'
    borderDiv.className = 'viewfinder-border'

    // Apply styles directly using JS CSS properties
    borderDiv.style.position = 'fixed'
    borderDiv.style.top = '0'
    borderDiv.style.left = '0'
    borderDiv.style.width = '100vw'
    borderDiv.style.height = '100vh'
    borderDiv.style.border = `4px solid ${color}`
    borderDiv.style.pointerEvents = 'none'
    borderDiv.style.zIndex = '9999'
    borderDiv.style.boxSizing = 'border-box'

    document.body.appendChild(borderDiv)
  }
  private removeViewfinderBorder() {
    const border = document.getElementById('viewfinder-border')
    if (border) {
      border.remove()
    }
  }
  private drawGrid() {
    const currentUrl = window.location.href
    const urlObj = new URL(currentUrl)
    const flowParam = urlObj.searchParams.get('flow')
    const isDemo = urlObj.searchParams.get('isDemo');
    const gridContainer = document.createElement('div')
    gridContainer.id = 'grid-container'
    gridContainer.setAttribute('grid-container', 'true') // Unique attribute for identification
    gridContainer.style.position = 'absolute'
    gridContainer.style.top = '0'
    gridContainer.style.left = '0'
    gridContainer.style.width = '100vw'
    gridContainer.style.height = '100vh'
    gridContainer.style.display = 'grid'
    gridContainer.style.gridTemplateColumns = '1fr 1fr 1fr'
    gridContainer.style.gridTemplateRows = '1fr 1fr 1fr'
    gridContainer.style.zIndex = '10'
    if (isDemo) {
      gridContainer.style.opacity = 0;
    } else {
      gridContainer.style.opacity = 0.7;
    }
    // Clear previous grid cells if needed
    this.gridCells = []

    for (let i = 0; i < 9; i++) {
      const cell = document.createElement('div')
      cell.style.border = '0.2px solid #FFFFFF' // Default color (White)
      this.gridCells.push(cell)
      gridContainer.appendChild(cell)
    }

    this.overlay.appendChild(gridContainer)
  }
  private removeGrid() {
    const gridContainer = this.overlay.querySelector('div[grid-container]')
    if (gridContainer) {
      gridContainer.remove() // Remove the grid without affecting other elements
    }
  }
  private changeGridColor(duration: number) {
    if (!this.gridCells.length) return

    // Change border color to #00FF80 (Green)
    this.gridCells.forEach((cell) => {
      cell.style.border = '0.2px solid #00FF80'
    })

    // Revert back after x seconds
    setTimeout(() => {
      this.gridCells.forEach((cell) => {
        cell.style.border = '0.2px solid #FFFFFF' // Revert to White
      })
    }, duration)
  }
  private updateOverlaySize() {
    this.overlay.style.width = '100vw'
    this.overlay.style.height = '100vh'
    this.drawGrid()
  }
  private cleanup() {
    this.stop()
  }
  private updateCanvasSize = () => {
    this.videoWidth = this.videoElement.videoWidth
    this.videoHeight = this.videoElement.videoHeight
    this.videoOffsetWidth = this.videoElement.offsetWidth
    this.videoOffsetHeight = this.videoElement.offsetHeight
    this.canvas.width = this.videoOffsetWidth
    this.canvas.height = this.videoOffsetHeight
  }

  public startDisplayingMessages(msg: string[]) {
    const messages = msg
    let index = 0

    this.intervalId = setInterval(() => {
      this.showToast(messages[index])
      index = (index + 1) % messages.length // Cycle through the messages
    }, 1000) // Change message every 4 seconds
  }
  public stopDisplayingMessages() {
    if (this.intervalId !== null) {
      this.hideToast()
      clearInterval(this.intervalId) // Stop the message display
      this.intervalId = null // Clear the intervalId
    }
  }

  private showBlackToast(message: string) {
    // Create style only once
    if (!document.getElementById('black-toast-style')) {
      const style = document.createElement('style')
      style.id = 'black-toast-style'
      style.innerHTML = `
        .black-toast {
          position: fixed;
          bottom: 100px;
          left: 50%;
          transform: translateX(-50%);
          background: #222222;
          color: white;
          font-family: 'Open Sans';
          font-weight: 700;
          padding: 10px 35px;
          border-radius: 40px;
          font-size: 13px;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
          z-index: 500;
          display: inline-block;
          max-width: 90vw; /* Prevents excessive width */
          text-align: center;
          white-space: nowrap; /* Ensures text stays in a single line */
        }
      `
      document.head.appendChild(style)
    }

    // Remove any existing toast before creating a new one
    this.hideBlackToast()

    // Create the toast element
    const toast = document.createElement('div')
    toast.className = 'black-toast'
    toast.innerText = message
    toast.id = 'black-toast'

    // Add click event listener to call this.handleScanAgain
    toast.addEventListener('click', () => this.handleScanAgain())

    document.body.appendChild(toast)
  }

  private hideBlackToast() {
    const existingToast = document.getElementById('black-toast')
    if (existingToast) {
      existingToast.remove()
    }
  }
  private showBouncingArrow() {
    const currentUrl = window.location.href;
    const urlObj = new URL(currentUrl)
    const isDemo = urlObj.searchParams.get('isDemo');
    if (isDemo) {
      return;
    }
    // Create style only once
    if (!document.getElementById('bouncing-arrow-style')) {
      const style = document.createElement('style')
      style.id = 'bouncing-arrow-style'
      style.innerHTML = `
        @keyframes bounceArrow {
          0% { 
            transform: translateX(-50%) translateY(0); 
            animation-timing-function: ease-in; 
          }
          20% { 
            transform: translateX(-50%) translateY(-20px); 
            animation-timing-function: ease-in; 
          }
          80% { 
            transform: translateX(-50%) translateY(-20px); 
            animation-timing-function: linear; 
          }
          100% { 
            transform: translateX(-50%) translateY(0); 
            animation-timing-function: ease-in; 
          }
        }
  
        .bouncing-arrow-container {
          position: fixed;
          bottom: 2%;
          left: 50%;
          transform: translateX(-50%);
          width: 36px;
          height: 36px;
          background: rgba(0, 0, 0, 0.4);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 500;
          cursor: pointer;
          animation: bounceArrow 2s infinite;
        }
  
        .bouncing-arrow-container img {
          width: 18px;
          height: 18px;
        }
      `
      document.head.appendChild(style)
    }

    // Remove existing arrow if present
    const existingArrow = document.getElementById('bouncing-arrow')
    if (existingArrow) {
      existingArrow.remove()
    }

    // Create the arrow container
    const arrowContainer = document.createElement('div')
    arrowContainer.className = 'bouncing-arrow-container'
    arrowContainer.id = 'bouncing-arrow'

    // Append the imported SVG as an image
    const arrowImg = document.createElement('img')
    arrowImg.src = ArrowIcon // Ensure UpperArrow is a valid URL or path
    arrowImg.alt = 'Up Arrow'

    arrowImg.onload = () => {
      // Ensure the click event works once the image is loaded
      arrowContainer.addEventListener('click', () => {
        if (this.showBrandPopup) {
          this.toggleBrandEngagement(this.uidConfig?.brandEngagement);
        } else {
          window.location.href = this.brandEngagementLink;
        };
        this.posthogEvent.sendPostHogEvent('brand_engagement_triggered', {
          result: 'success',
          redirected_url: this.brandEngagementLink,
          verificationSessionId: this.legacySessionId,
          sessionId: this.sessionId,
        })
      })
    }

    arrowContainer.appendChild(arrowImg)
    document.body.appendChild(arrowContainer)
  }
  private hideBouncingArrow() {
    const arrowContainer = document.getElementById('bouncing-arrow')
    if (arrowContainer) {
      arrowContainer.remove()
    }
  }

  private showProductIdentification(productConfigId = '', decoderConfigId = '') {
    this.posthogEvent.sendPostHogEvent('object_detected', {
      product_scan_id: productConfigId,
      sessionId: this.sessionId,
      verificationSessionId: this.legacySessionId,
      decoderConfigId: decoderConfigId,
    })
    if (productConfigId && productConfigId.toLowerCase() && productConfigId.toLowerCase().includes('hul')) {
      this.brandEngagementLink = 'https://www.hul.co.in/brands/foods/brooke-bond-3-roses/';
      this.showBrandPopup = true;
    } else if (productConfigId && productConfigId.toLowerCase() && productConfigId.toLowerCase().includes('cnhi')) {
      this.brandEngagementLink = 'https://www.mycnhstore.com/amea/en/default?site=amea&clear=true';
      this.showBrandPopup = false;
    };
    this.productConfigId = productConfigId;
    this.decoderConfigId = decoderConfigId;
    this.stopProcessingDetects = true
    this.createToast(this.languageConfig.productIdentified, '#242424', '#FFFFFF', '')
    this.changeGridColor(1000)
    if (this.flow === FLOW.IMAGE_STREAM && productConfigId && !this.isSessionStarted) {
      console.log('TriggerLoginSession')
      this.getLoginAndSession(productConfigId)
      this.isSessionStarted = false
    }
    setTimeout(() => {
      this.isProductIdentified = true
      this.stopProcessingDetects = false
    }, 1000)
  }
  private async getLoginAndSession(productConfigId = '') {
    const API_KEY = String(config.API_KEY)
    const res = await APIs.login(API_KEY)
    const accessToken = res?.access_token
    const devices = await navigator.mediaDevices.enumerateDevices()
    if (accessToken && productConfigId) {
      const cords = this.cords
      const res = await APIs.fetchExperience(productConfigId, accessToken)
      const imageCount = res?.experience_config?.image_count
      const brandEngagementData = res?.experience_config?.brand_engagement || {};
      const resStartSession = await APIs.startSession(res?.product_config_id, accessToken, cords, {
        camList: devices,
      })
      const legacySessionId = resStartSession?.session_id || ''
      this.legacySessionId = legacySessionId
      console.log('LegacySessionID', legacySessionId);
      this.accessToken = accessToken
      this.imageCount = imageCount;
      this.brandEngagementData = brandEngagementData;
    }
  }
  private convertCoordinatesToViewFinder(
    coords: [number, number, number, number],
    videoWidth: number,
    videoHeight: number,
    viewfinderWidth: number,
    viewfinderHeight: number,
  ) {
    if (!coords || coords.length !== 4) {
      console.error('Invalid coordinates')
      return { x: 0, y: 0, width: 0, height: 0 }
    }

    const [x, y, xmax, ymax] = coords

    // Calculate scaling factors between video and viewfinder
    const scaleX = viewfinderWidth / videoWidth
    const scaleY = viewfinderHeight / videoHeight

    // Apply the scaling to coordinates
    const scaledX = x * scaleX
    const scaledY = y * scaleY
    const scaledWidth = (xmax - x) * scaleX
    const scaledHeight = (ymax - y) * scaleY

    return { x: scaledX, y: scaledY, width: 400, height: 500 }
  }
  private getCenter50PercentOfVideo(
    videoWidth: number,
    videoHeight: number,
  ): [number, number, number, number] {
    // Calculate the dimensions for the center 50% region
    const centerWidth = videoWidth * 0.5
    const centerHeight = videoHeight * 0.5

    // Calculate the top-left (x, y) corner of the center region
    const centerX = (videoWidth - centerWidth) / 2
    const centerY = (videoHeight - centerHeight) / 2

    // Calculate the bottom-right coordinates (xmax, ymax)
    const xmax = centerX + centerWidth
    const ymax = centerY + centerHeight

    // Return the coordinates as [x, y, xmax, ymax]
    return [centerX, centerY, xmax, ymax]
  }
  private showProductVerification(coords = []) {
    this.createToast(
      this.languageConfig.verificationInProgress,
      '#242424',
      '#FFFFFF',
      '',
    )
    const videoElement = document.querySelector('video') // Change selector if needed
    if (!videoElement) {
      console.error('Video element not found')
      return
    }

    const videoWidth = videoElement.videoWidth || videoElement.clientWidth
    const videoHeight = videoElement.videoHeight || videoElement.clientHeight
    const viewfinderWidth = window.innerWidth
    const viewfinderHeight = window.innerHeight
    const rect = this.getCenter50PercentOfVideo(videoWidth, videoHeight) //this.convertCoordinatesToViewFinder(coords, videoWidth, videoHeight, viewfinderWidth, viewfinderHeight);
    const screenWidth = window.innerWidth
    const screenHeight = window.innerHeight

    // Define the center 50% region
    const width = screenWidth * 0.5
    const height = screenHeight * 0.35
    const x = (screenWidth - width) / 2
    const y = (screenHeight - height) / 2

    this.createPulsatingBubbles({ x, y, width, height })
  }
  private async sendImages() {
    // Ensure videoElement is valid
    if (!this.videoElement || this.videoElement.readyState < 2) {
      console.error('Video element is not ready or not defined.')
      return
    }

    // Create a hidden canvas (not attached to DOM)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')!

    // Set canvas to match video's native resolution for best quality
    const width = this.videoElement.videoWidth
    const height = this.videoElement.videoHeight
    canvas.width = width
    canvas.height = height

    // Log resolution for debugging
    console.log(`Capturing at resolution: ${width}x${height}`)

    // Capture a single image and return Base64 with maximum quality
    const captureImage = (): Promise<string | null> => {
      return new Promise((resolve) => {
        // Draw the current video frame onto the hidden canvas
        ctx.drawImage(this.videoElement, 0, 0, width, height)

        // Get Base64 string with maximum JPEG quality
        try {
          const base64 = canvas.toDataURL('image/jpeg', 1.0) // 1.0 for best quality
          // Alternative: Use PNG for lossless quality (uncomment if needed)
          // const base64 = canvas.toDataURL('image/png');
          resolve(base64)
        } catch (error) {
          webLogger.error('Error converting canvas to Base64', error)
          console.error('Failed to convert canvas to Base64:', error)
          resolve(null)
        }
      })
    }

    // Capture and process one image
    const base64 = await captureImage()
    if (base64) {
      const imgFile = dataURLtoFile(base64, 'capture.jpg')
      const formData = new FormData()
      if (imgFile) formData.append('input_image', imgFile)

      try {
        const res = await APIs.uploadImage(this.legacySessionId, formData, this.accessToken)
        console.log(`Image ${this.legacyImageCount + 1} uploaded successfully:`, res)

        // Store Base64 for debugging (optional)
        const capturedImages: string[] = [] // Local array for this call
        capturedImages.push(base64)
        console.log(
          `Captured image ${this.legacyImageCount + 1} (Base64, size: ${(
            base64.length / 1024
          ).toFixed(2)} KB):`,
          base64,
        )
        console.log(`Images captured so far: ${this.legacyImageCount}`)
        if (this.legacyImageCount === this.imageCount) {
          console.log(`Finished capturing ${this.imageCount} images.`)
        }
      } catch (error) {
        webLogger.error('Error uploading image', error)
        console.error('Failed to upload image:', error)
      }
    } else {
      console.error('No Base64 image captured.')
    }
  }
  private async initiatePoll() {
    const payload = {
      streamSessionId: this.sessionId,
      verificationSessionsId: this.legacySessionId,
    }
    console.log('-------Initated polling--------', this.sessionId, this.legacySessionId, this.accessToken);
    const res = await APIs.initiatePoll(`${config.API_URL}/poll`, payload, this.accessToken)
  }

  // Add this function to your class
  private async sendSessionResult(result: string, analysisResult: number, uiResult: string, genuine_threshold: number, fake_threshold: number, sessionId: string) {
    const uId = this.clientId;
    const clientIdMappings = this.appConfig?.clientIdMappings || {};
    const geoLat = this.cords?.lat?.toString();
    const geoLong = this.cords?.long?.toString();
    const geoSource = this.cords?.source || 'unknown';
    const isLocationUpdated = this.cords?.isUpdated || false;
    const sessionData = {
      sessionId: sessionId,
      source: 'stream',
      result: result,
      sessionCompletedAt: new Date().toISOString(),
      analysisResult: analysisResult,
      imageCountConfig: JSON.stringify({
        genuine_threshold: genuine_threshold,
        fake_threshold: fake_threshold
      }),
      uiResult: uiResult,
    };
    sessionData.geo_address = {
      geo_lat: geoLat,
      geo_long: geoLong,
      geo_source: geoSource,
    }
    
    try {
      this.posthogEvent.sendPostHogEvent('session_result_triggered', {
        sessionId: sessionId,
        sessionData,
      });
      const response = await fetch(`${config.API_URL}/session-result`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(sessionData)
      });

      if (!response.ok) {
        console.error('Failed to send session result:', response.status, response.statusText);
        this.posthogEvent.sendPostHogEvent('session_result_failed', {
          sessionId: sessionId,
          error: 'Failed to send session result',
          status: response.status,
          statusText: response.statusText,
        });
      } else {
        this.posthogEvent.sendPostHogEvent('session_result_success', {
          sessionId: sessionId,
        });
        if(clientIdMappings[uId] === 'HUL'){
            this.sendQrSerial(result, sessionId);
        }
        console.log('Session result sent successfully');
      }
    } catch (error) {
      this.posthogEvent.sendPostHogEvent('session_result_failed', {
        sessionId: sessionId,
        error,
      });
      webLogger.error('Error sending session result', error);
      console.error('Error sending session result:', error);
    }
  }

 private getShortIdFromUrl(): string | null {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('shortId');
  } catch (error) {
    console.error('Error extracting shortId from URL:', error);
    return null;
  }
}

private async sendQrSerial(result = '', sessionId = '') {
  const shortId = this.getShortIdFromUrl();
  
  if (!shortId) {
    console.error('shortId not found in URL parameters');
    this.posthogEvent.sendPostHogEvent('qr_serial_failed', {
      sessionId: sessionId,
      error: 'shortId not found in URL parameters',
    });
    return null;
  }

  const requestData = {
    data: {
      context: {
        location: {
          lat: this.cords?.lat,
          long: this.cords?.long,
        }
      },
      sessionId: sessionId,
      shortId: shortId,
    }
  };

  if(result === 'GENUINE'){
    requestData.data.limitCounter = true;
    requestData.data.generalCounter = false;
  } else {
    requestData.data.limitCounter = false;
    requestData.data.generalCounter = true;
  }

  try {
    this.posthogEvent.sendPostHogEvent('qr_serial_request', {
      sessionId: sessionId,
      shortId: shortId,
    });

    const response = await fetch(`${config.API_URL}/api/starlink/v1/qr/serial`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData)
    });

    if (!response.ok) {
      console.error('Failed to send QR serial request:', response.status, response.statusText);
      this.posthogEvent.sendPostHogEvent('qr_serial_failed', {
        sessionId: sessionId,
        shortId: shortId,
        error: 'Failed to send QR serial request',
        status: response.status,
        statusText: response.statusText,
      });
      return null;
    } else {
      const responseData = await response.json();
      this.posthogEvent.sendPostHogEvent('qr_serial_success', {
        sessionId: sessionId,
        shortId: shortId,
      });
      console.log('QR serial request sent successfully');
      return responseData;
    }
  } catch (error) {
    this.posthogEvent.sendPostHogEvent('qr_serial_failed', {
      sessionId: sessionId,
      shortId: shortId,
      error,
    });
    webLogger.error('Error sending QR serial request', error);
    console.error('Error sending QR serial request:', error);
    return null;
  }
}

  // Updated handleDetectionLabel function with API calls
private handleDetectionLabel(label = '', probability = 0) {
  const uidResultConfig = this.uidConfig?.resultConfig || {};    
  const resultConfig = this.appConfig?.resultConfig || {};
  const decoderIdResultConfig = this.uidConfig?.decoderIdResultConfig || {};
  
  // Merge configs with uidResultConfig taking precedence over resultConfig
  const mergedConfig = { ...resultConfig, ...uidResultConfig };
  
  const currentUrl = window.location.href
  const urlObj = new URL(currentUrl)
  const secondParam = urlObj.searchParams.get('second')
  const genuineNo = urlObj.searchParams.get('genuine')
  const isDemo = urlObj.searchParams.get('isDemo');
  const fakeColor = isDemo ? '#FFF4D5' : '#FFF4D5';
  
  // Check if decoderConfigId matches any key in decoderIdResultConfig
  const decoderSpecificConfig = this.decoderConfigId && decoderIdResultConfig[this.decoderConfigId] 
    ? decoderIdResultConfig[this.decoderConfigId] 
    : null;
  
  // Set counts with proper precedence: decoderSpecificConfig > mergedConfig > defaults
  const genuineCountConfig = decoderSpecificConfig?.genuineCount ?? mergedConfig.genuineCount ?? 1;
  const fakeCountConfig = decoderSpecificConfig?.fakeCount ?? mergedConfig.fakeCount ?? 10;
  const cannotConfirmConfig = decoderSpecificConfig?.cannotConfirmCount ?? mergedConfig.cannotConfirmCount ?? 10;
  
  const genuineCount = genuineCountConfig;
  const maxRejectCount = fakeCountConfig;
  const fakeCount = fakeCountConfig;
  const maxCannotConfirmCount = cannotConfirmConfig;
  const timeLimit = secondParam || isDemo ? parseInt(secondParam, 15) : null;
  const sessionId = String(this.sessionId);
  const resultConfigurations = mergedConfig || {};
  
  this.detectionQueue.push(label)
  if (label === 'accept') {
    this.acceptCount = this.acceptCount + 1
  } else if (label === 'reject') {
    this.rejectCount = this.rejectCount + 1
  } else if (label === 'cannot_confirm') {
    this.cannotConfirmCount = this.cannotConfirmCount + 1
  }
  const p = Number(probability.toFixed(2))
  if (this.isTest) {
    this.showToast(`${label} - ${p}`)
  }
  if (!this.resultsShown && !this.isTest) {
    const elapsedTime = (Date.now() - this.startTime) / 1000 // Calculate elapsed time in seconds
    console.log('ElapsedTime', elapsedTime, 'timeLimit', timeLimit)
    if (
      (timeLimit && elapsedTime <= timeLimit && this.acceptCount > genuineCount - 1) ||
      (this.acceptCount && this.flow === FLOW.IMAGE_STREAM)
    ) {
      this.sendSessionResult('GENUINE', 0, 'GENUINE', genuineCount, fakeCount, sessionId)
      this.stop()
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
      clearTimeout(this.tenSecondTimeout)
      this.tenSecondTimeout = ''
      this.resultsShown = true
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.detectedResult = true
      this.removeAllToasts()
      //this.createToast(this.languageConfig.productGenuine, '#076737', '#FFFFFF', TickIcon)
      //this.highlightViewfinderBorder('rgba(12, 221, 115, 1)')
      this.removeGrid()
      this.removeCornerOverlay()
      this.posthogEvent.sendPostHogEvent('results_generated', {
        result: 'success',
        sessionId: sessionId,
        predictionResult: 0,
        predictionText: this.languageConfig.productGenuine,
        verificationSessionId: this.legacySessionId,
      })
      this.createResultContainer(resultConfigurations['GENUINE']);
      // Call the API for genuine result
      setTimeout(() => {
        this.removeAllToasts()
        // this.createDropdownMessage(
        //   TickIcon,
        //   this.languageConfig.genuine,
        //   this.languageConfig.productGenuine,
        //   '#076737',
        //   '#FFFFFF',
        //   '',
        // )
        this.removeViewfinderBorder()
        // this.showBlackToast(this.languageConfig.scanAgain)
        // this.showBouncingArrow()
      }, 2000)
    } else if (
      (elapsedTime > timeLimit && secondParam) ||
      (this.rejectCount && this.flow === FLOW.IMAGE_STREAM) || (this.rejectCount > (maxRejectCount - 1))
    ) {
      this.sendSessionResult('FAKE', 1, 'FAKE', genuineCount, fakeCount, sessionId)
      this.stop()
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
      clearTimeout(this.tenSecondTimeout)
      this.tenSecondTimeout = ''
      //this.stopImageSending();
      this.removeAllToasts()
      //this.createToast(this.languageConfig.unableToAuthenticate, fakeColor, '#AA7E00', ErrorIcon)
      //this.highlightViewfinderBorder(fakeColor)
      this.removeGrid()
      this.removeCornerOverlay()
      this.resultsShown = true
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.posthogEvent.sendPostHogEvent('results_generated', {
        result: 'success',
        sessionId: sessionId,
        predictionResult: 1,
        predictionText: this.languageConfig.unableToAuthenticate,
        verificationSessionId: this.legacySessionId,
      })
      this.createResultContainer(resultConfigurations['FAKE']);
      // Call the API for fake result
      this.detectedResult = false
      setTimeout(() => {
        this.removeAllToasts()
        // this.createDropdownMessage(
        //   ErrorIcon,
        //   this.languageConfig.unableToAuthenticate,
        //   '',
        //   fakeColor,
        //   '#AA7E00',
        //   '#AA7E00',
        // )
        this.removeViewfinderBorder()
        // this.showBlackToast(this.languageConfig.scanAgain)
        // this.showBouncingArrow()
      }, 2000)
    } else if (this.cannotConfirmCount > (maxCannotConfirmCount - 1)) {
      this.sendSessionResult('CANNOT_CONFIRM', 2, 'TRY_AGAIN', genuineCount, fakeCount, sessionId)
      this.stop()
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
      clearTimeout(this.tenSecondTimeout)
      this.tenSecondTimeout = ''
      this.resultsShown = true
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.detectedResult = true
      this.removeAllToasts()
      //this.createToast(this.languageConfig.cannotConfirm, '#FFF4D5', '#AA7E00', '')
      //this.highlightViewfinderBorder('#FFF4D5')
      this.removeGrid()
      this.removeCornerOverlay()
      this.createResultContainer(resultConfigurations['CANNOT_CONFIRM']);
      this.posthogEvent.sendPostHogEvent('results_generated', {
        result: 'success',
        sessionId: sessionId,
        predictionResult: -1,
        predictionText: this.languageConfig.cannotConfirm,
        verificationSessionId: this.legacySessionId,
      })
      // Call the API for genuine result
      setTimeout(() => {
        this.removeAllToasts()
        // this.createDropdownMessage(
        //   CANNOT_CONFIRM_ICON,
        //   this.languageConfig.cannotConfirm,
        //   '',
        //   '#FFF4D5',
        //   '#AA7E00',
        //   '',
        // )
        this.removeViewfinderBorder()
        // this.showBlackToast(this.languageConfig.scanAgain)
        // this.showBouncingArrow()
      }, 2000);
    } else if (elapsedTime > timeLimit || !secondParam) {
      if (this.acceptCount > (genuineCount - 1)) {
        this.sendSessionResult('GENUINE', 0, 'GENUINE', genuineCount, fakeCount, sessionId)
        this.stop()
        if (this.interval) {
          clearInterval(this.interval)
          this.interval = null
        }
        this.removeAllToasts()
        this.resultsShown = true
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        this.detectedResult = true
        //this.createToast(this.languageConfig.productGenuine, '#076737', '#FFFFFF', TickIcon)
        //this.highlightViewfinderBorder('#0CDD73')
        this.createResultContainer(resultConfigurations['GENUINE']);
        this.removeGrid()
        this.removeCornerOverlay()
        this.posthogEvent.sendPostHogEvent('results_generated', {
          result: 'success',
          sessionId: sessionId,
          predictionResult: 0,
          predictionText: this.languageConfig.productGenuine,
          verificationSessionId: this.legacySessionId,
        })
        // Call the API for genuine result
        setTimeout(() => {
          this.removeAllToasts()
          // this.createDropdownMessage(
          //   TickIcon,
          //   this.languageConfig.genuine,
          //   this.languageConfig.productGenuine,
          //   '#076737',
          //   '#FFFFFF',
          // )
          this.removeViewfinderBorder()
          // this.showBlackToast(this.languageConfig.scanAgain)
          // this.showBouncingArrow()
        }, 2000)
      } else if (this.rejectCount > maxRejectCount) {
        this.sendSessionResult('FAKE', 1, 'FAKE', genuineCount, fakeCount, sessionId)
        this.stop()
        if (this.interval) {
          clearInterval(this.interval)
          this.interval = null
        }
        //this.stopImageSending();
        this.removeAllToasts()
         this.createResultContainer(resultConfigurations['FAKE']);
        //this.createToast(this.languageConfig.unableToAuthenticate, fakeColor, '#FFFFFF', ErrorIcon)
        //this.highlightViewfinderBorder(fakeColor)
        this.removeGrid()
        this.removeCornerOverlay()
        this.resultsShown = true
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        this.detectedResult = false
        this.posthogEvent.sendPostHogEvent('results_generated', {
          result: 'success',
          sessionId: sessionId,
          predictionResult: 1,
          predictionText: this.languageConfig.unableToAuthenticate,
          verificationSessionId: this.legacySessionId,
        })
        // Call the API for fake result
        setTimeout(() => {
          this.removeAllToasts()
          // this.createDropdownMessage(
          //   ErrorIcon,
          //   this.languageConfig.unableToAuthenticate,
          //   '',
          //   fakeColor,
          //   '#FFFFFF',
          // )
          this.removeViewfinderBorder()
          // this.showBlackToast(this.languageConfig.scanAgain)
          // this.showBouncingArrow()
        }, 2000)
      }
    }
  }
}

private createResultContainer(resultConfig = {}): void {
  console.log('this.languageConfig', this.languageConfig, this.appConfig)
  const existingContainer = document.querySelector('.result-container');
  if (existingContainer) {
    return;
  }
  
  // Helper function to get localized text
  const getText = (key) => {
    return this.languageConfig?.[key];
  };
  
  // Create and inject styles first
  const styleId = 'result-container-styles';
  if (!document.getElementById(styleId)) {
    const styleElement = document.createElement('style');
    styleElement.id = styleId;
    styleElement.innerHTML = `
      @keyframes slideUp {
        from { 
          bottom: -300px; 
        }
        to { 
          bottom: 70%; 
          transform: translateX(-50%) translateY(70%); 
        }
      }
      
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
    `;
    document.head.appendChild(styleElement);
  }

  const resultContainer = document.createElement('div');
  resultContainer.className = 'result-container';
  resultContainer.id = 'vyu-result-container';
  console.log('Result Config', resultConfig);
  
  // Apply inline styles for the slide up animation
  Object.assign(resultContainer.style, {
    position: 'fixed',
    left: '50%',
    bottom: '-300px',
    transform: 'translateX(-50%)',
    backgroundColor: resultConfig.bgColour || 'white',
    borderRadius: '10px',
    padding: '20px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
    width: '80%',
    maxWidth: '320px',
    maxHeight: '80vh',
    overflowY: 'auto',
    zIndex: '101',
    border: '1px solid',
    borderColor: resultConfig.statusColour || '#000',
    boxSizing: 'border-box',
    animation: 'slideUp 0.8s ease-out forwards'
  });

  const iconElement = document.createElement('img');
  iconElement.src = resultConfig.icon;
  iconElement.alt = getText(resultConfig.statusKey);
  iconElement.className = 'result-icon';
  iconElement.style.width = '50px';
  iconElement.style.height = '50px';
  iconElement.style.marginBottom = '15px';

  const statusElement = document.createElement('div');
  statusElement.textContent = getText(resultConfig.statusKey);
  statusElement.className = 'result-status';
  statusElement.style.margin = '0 0 10px 0';
  statusElement.style.color = resultConfig.statusColour || '#000';
  statusElement.style.fontSize = '24px';
  statusElement.style.fontWeight = '700';
  
  let textElement = null;

  if (this.serialId) {
    const serialContainer = document.createElement('div');
    serialContainer.className = 'result-serial-container';
    serialContainer.style.margin = '0 0 20px 0';
    serialContainer.style.padding = '8px 20px';
    serialContainer.style.borderRadius = '8px';
    serialContainer.style.backgroundColor = resultConfig.textBgColour || 'rgba(243, 243, 243, 1)';

    const serialLabel = document.createElement('div');
    serialLabel.textContent = 'Serial ID';
    serialLabel.className = 'result-serial-label';
    serialLabel.style.color = '#2222227A';
    serialLabel.style.opacity = '0.5';
    serialLabel.style.fontSize = '12px';
    serialLabel.style.fontWeight = '700';
    serialLabel.style.marginBottom = '5px';

    const serialValue = document.createElement('div');
    serialValue.textContent = this.serialId;
    serialValue.className = 'result-serial-value';
    serialValue.style.color = '#333';
    serialValue.style.fontSize = '14px';
    serialValue.style.fontWeight = '700';

    serialContainer.appendChild(serialLabel);
    serialContainer.appendChild(serialValue);
    textElement = serialContainer;
  } else {
    textElement = document.createElement('div');
    textElement.textContent = getText(resultConfig.textKey);
    textElement.className = 'result-text';
    textElement.style.margin = '0 0 20px 0';
    textElement.style.color = '#333';
    textElement.style.fontSize = '14px';
    textElement.style.fontWeight = '400';
    textElement.style.padding = '8px 20px';
    textElement.style.borderRadius = '8px';
    textElement.style.backgroundColor = resultConfig.textBgColour || 'rgba(243, 243, 243, 1)';
  }

  resultContainer.appendChild(iconElement);
  resultContainer.appendChild(statusElement);
  if (textElement) resultContainer.appendChild(textElement);

  // Create separate button container with specific class and ID
  const buttonContainer = document.createElement('div');
  buttonContainer.className = 'result-button-container';
  buttonContainer.id = 'vyu-button-container';
  buttonContainer.style.position = 'fixed';
  buttonContainer.style.left = '50%';
  buttonContainer.style.transform = 'translateX(-50%)';
  buttonContainer.style.width = '80%';
  buttonContainer.style.maxWidth = '320px';
  buttonContainer.style.display = 'flex';
  buttonContainer.style.flexDirection = 'column';
  buttonContainer.style.gap = '12px';
  buttonContainer.style.zIndex = '102';
  buttonContainer.style.opacity = '0';
  buttonContainer.style.transition = 'opacity 0.5s ease-out';

  if (resultConfig.scanAgainKey) {
    const scanAgainButton = document.createElement('button');
    scanAgainButton.textContent = getText(resultConfig.scanAgainKey);
    scanAgainButton.className = 'result-scan-again-btn';
    scanAgainButton.id = 'vyu-scan-again-button';
    Object.assign(scanAgainButton.style, {
      padding: '14px',
      borderRadius: '8px',
      backgroundColor: '#ffffff',
      color: 'rgba(68, 68, 68, 1)',
      border: 'none',
      fontSize: '16px',
      cursor: 'pointer',
      width: '100%',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    });

    if (resultConfig.scanAgainIcon) {
      const iconImg = document.createElement('img');
      iconImg.src = resultConfig.scanAgainIcon;
      iconImg.alt = 'scan again icon';
      iconImg.className = 'result-scan-again-icon';
      iconImg.style.width = '16px';
      iconImg.style.height = '16px';
      iconImg.style.marginLeft = '4px';
      iconImg.style.flexShrink = '0';
      scanAgainButton.appendChild(iconImg);
    }
    scanAgainButton.addEventListener('click', () => this.handleScanAgain());
    buttonContainer.appendChild(scanAgainButton);
  }

  if (resultConfig.button1Key) {
    const button1 = document.createElement('button');
    button1.textContent = getText(resultConfig.button1Key);
    button1.className = 'result-button-1';
    button1.id = 'vyu-button-1';
    Object.assign(button1.style, {
      padding: '14px',
      borderRadius: '8px',
      backgroundColor: resultConfig.background || '#ffffff',
      color: 'rgba(68, 68, 68, 1)',
      fontSize: '16px',
      cursor: 'pointer',
      width: '100%',
      fontWeight: '600',
      borderColor: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    });

    if (resultConfig.button1Icon) {
      const iconImg = document.createElement('img');
      iconImg.src = resultConfig.button1Icon;
      iconImg.alt = 'button1 icon';
      iconImg.className = 'result-button-1-icon';
      iconImg.style.width = '16px';
      iconImg.style.height = '16px';
      iconImg.style.marginLeft = '4px';
      iconImg.style.flexShrink = '0';
      button1.appendChild(iconImg);
    }
    
    button1.addEventListener('click', () => {
      if (this.posthogEvent) {
        this.posthogEvent.sendPostHogEvent('button_clicked', {
          button_text: getText(resultConfig.button1Key),
          redirect_url: resultConfig.button1Link || '',
          result_status_on_screen: getText(resultConfig.statusKey),
          timestamp: new Date().toISOString(),
        });
      }
      if (getText(resultConfig.button1Key) === getText('knowMore') && this.uidConfig?.brandEngagement) {
       this.toggleBrandEngagement(this.uidConfig?.brandEngagement);
      } else if (resultConfig.button1Link) {
        let url = resultConfig.button1Link;
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = 'https://' + url;
        }
        window.open(url, '_blank');
      }
    });

    buttonContainer.appendChild(button1);
  }

  if (resultConfig.button2Key && resultConfig.button2Link) {
    const button2 = document.createElement('button');
    button2.textContent = getText(resultConfig.button2Key);
    button2.className = 'result-button-2';
    button2.id = 'vyu-button-2';
    Object.assign(button2.style, {
      padding: '14px',
      borderRadius: '8px',
      backgroundColor: '#ffffff',
      color: 'rgba(68, 68, 68, 1)',
      fontSize: '16px',
      cursor: 'pointer',
      width: '100%',
      fontWeight: '600',
      borderColor: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    });

    if (resultConfig.button2Icon) {
      const iconImg = document.createElement('img');
      iconImg.src = resultConfig.button2Icon;
      iconImg.alt = 'button2 icon';
      iconImg.className = 'result-button-2-icon';
      iconImg.style.width = '16px';
      iconImg.style.height = '16px';
      iconImg.style.marginLeft = '4px';
      iconImg.style.flexShrink = '0';
      button2.appendChild(iconImg);
    }

    button2.addEventListener('click', () => {
      if (this.posthogEvent) {
        this.posthogEvent.sendPostHogEvent('button_clicked', {
          button_text: getText(resultConfig.button2Key),
          redirect_url: resultConfig.button2Link || '',
          result_status_on_screen: getText(resultConfig.statusKey),
          button_position: 'button2',
          timestamp: new Date().toISOString(),
        });
      }
  
    if (getText(resultConfig.button2Key) === getText('report') || 
        getText(resultConfig.button2Key) === getText('reportFake')) {
      if (this.showReportPopupCallback && this.uidConfig?.reportConfig) {
        this.showReportPopupCallback({
          sessionId: this.sessionId,
          productInfo: {
            productConfigId: this.productConfigId,
            decoderConfigId: this.decoderConfigId
          },
          config: this.uidConfig?.reportConfig
        });
    }
  } else if (resultConfig.button2Link) {
    let url = resultConfig.button2Link;
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank');
  }
});

    buttonContainer.appendChild(button2);
  }

  // Append both containers to body
  document.body.appendChild(resultContainer);
  document.body.appendChild(buttonContainer);

  const isGenuineResult = resultConfig === (this.appConfig?.resultConfig?.['GENUINE'] || {});
  const hasGenuinePopupConfig = this.uidConfig?.genuineResultPopup;

  if (isGenuineResult && hasGenuinePopupConfig) {
    this.genuinePopupActive = true;
    setTimeout(() => {
      const resultRect = resultContainer.getBoundingClientRect();
      buttonContainer.style.top = `${resultRect.bottom + 20}px`;
    }, 1200);
  } else {
    setTimeout(() => {
      const resultRect = resultContainer.getBoundingClientRect();
      buttonContainer.style.top = `${resultRect.bottom + 20}px`;
      buttonContainer.style.opacity = '1';
    }, 1200);
  }
}

private clearResultContainer() {
  this.genuinePopupActive = false;
  const resultContainer = document.querySelector('.result-container');
  if (resultContainer) {
    resultContainer.remove();
  }

  const buttonContainer = document.querySelector('.result-button-container');
  if (buttonContainer) {
    buttonContainer.remove();
  }

  const resultContainerById = document.getElementById('vyu-result-container');
  if (resultContainerById) {
    resultContainerById.remove();
  }

  const buttonContainerById = document.getElementById('vyu-button-container');
  if (buttonContainerById) {
    buttonContainerById.remove();
  }

  const styleElement = document.getElementById('result-container-styles');
  if (styleElement) {
    styleElement.remove();
  }
}

  private handleScanAgain(): void {
    this.showRestart = false
    this.genuinePopupActive = false;
    if (this.interval !== null) {
      clearInterval(this.interval)
      this.interval = null
    }
    if (this.mqttClient && this.sessionId) {
      this.mqttClient?.unsubscribe(`${this.sessionId}-image-stream/results`)
      this.mqttClient?.end(false, () => {
        console.log('MQTT client disconnected.');
        this.posthogEvent.sendPostHogEvent('mqtt_connection_disconnected', {
          sessionId: this.sessionId,
        })
      })
      this.mqttClient?.off('message', this.messageHandler)
      this.sessionId = ''
    }
    this.posthogEvent.sendPostHogEvent('scan_restart', {
      //result: 'success',
    })
    webLogger.startNewSession()
    this.init(this.flow, true, this.toggleBrandEngagement, this.posthogEvent, this.ipLocation, this.languageConfig, this.clientId, this.appConfig, this.uidConfig)
  }
  public stop() {
    const sessionId = String(this.sessionId);
    if (this.detectionTimeout) {
      clearTimeout(this.detectionTimeout)
    }
    if (this.tenSecondTimeout) {
      clearTimeout(this.tenSecondTimeout)
    }
    this.posthogEvent.sendPostHogEvent('stop_triggered', {
      sessionId: sessionId,
    })
    this.stopBandwidthMonitoring()
    if (this.peerConnection) {
      console.log('xxxxxxxxxxxxxxxx Stop Triggered xxxxxxxxxxxxxxxxxxx')
      console.log('Session Terminated - Please reload to try again')
      this.peerConnection.close()
      this.peerConnection = null
      this.terminateImageSending = true
      this.startTime = ''
      this.legacySessionId = ''
      if (this.timeout) {
        clearInterval(this.timeout)
      }
      if (this.interval !== null) {
        clearInterval(this.interval)
        this.interval = null
      }
      this.mqttClient?.unsubscribe(`${sessionId}-image-stream/results`, (err) => {
        if (!err) {
          console.log(
            `Successfully unsubscribed from topic: ${sessionId}-image-stream/results`,
          )
          this.posthogEvent.sendPostHogEvent('mqtt_connection_topic_unsubscribed', {
            sessionId: sessionId,
          })
        } else {
          this.posthogEvent.sendPostHogEvent('mqtt_connection_unsubscribe_error', {
            sessionId: sessionId,
            error: err,
          })
          console.error(
            `Failed to unsubscribe from topic: ${sessionId}-image-stream/results`,
            err,
          )
        }
      })
      this.mqttClient?.publish(this.mqttSessionExpireTopic, sessionId)
      this.mqttClient?.removeListener('message', this.messageHandler)
      this.mqttClient?.off('message', this.messageHandler)

      if (this.mqttClient) {
        this.mqttClient.end(false, () => {
          console.log('MQTT client disconnected.')
          this.posthogEvent.sendPostHogEvent('mqtt_connection_client_ended', {
            sessionId: sessionId,
          })
        })
      }
      this.mqttClient = null
      this.sessionId = ''
      localStorage.setItem('sessionId', '')
      console.log('WebRTC stream stopped.')
      this.posthogEvent.sendPostHogEvent('webrtc_stream_stopped', {
        sessionId: sessionId,
      })
    }
    if (this.showRestart) {
      this.clearOverlay().then(() => {
        if (!this.resultsShown) {
          this.createToast(this.languageConfig.productNotInFocus, '#BE2705', '#FFFFFF', ErrorIcon)
        }
        this.showBlackToast(this.languageConfig.scanAgain)
        //this.showBouncingArrow()
      })
    }
  }

  // /* ----- Image Handling Solution ----- */
  // public async sendStreamImagesToTopic(numImagesPerSecond: number, durationInSeconds: number) {
  //   if (!this.sendImagesToTopic && !this.topicName) {
  //     this.sendImagesToTopic = true
  //     this.mqttClient?.publish('image-stream/start-planB', this.sessionId)
  //   }

  //   try {
  //     if (!this.stream || this.resultsShown) {
  //       console.error('No valid video stream available.')
  //       return
  //     }

  //     const totalImages = 10 * 600
  //     const intervalBetweenImages = 1000 / numImagesPerSecond // Milliseconds between images

  //     const publishImage = async (imageIndex: number) => {
  //       try {
  //         if (!this.stream) {
  //           console.error('Video stream not found.')
  //           return
  //         }

  //         if (!this.videoElement) {
  //           console.error('Video element not found.')
  //           return
  //         }
  //         const hiddenCanvas = document.createElement('canvas')
  //         const context = hiddenCanvas.getContext('2d')

  //         // Set the canvas size to match the full video resolution
  //         const { videoWidth, videoHeight } = this.videoElement
  //         if (this.isCrop) {
  //           const cropHeight = videoHeight * 0.5 // 50% of the video height
  //           const cropWidth = videoWidth // Full width
  //           const cropY = videoHeight * 0.25 // Start cropping from 25% height (leaving 25% at the top)
  //           hiddenCanvas.width = cropWidth
  //           hiddenCanvas.height = cropHeight
  //           context?.drawImage(
  //             this.videoElement,
  //             0,
  //             cropY,
  //             cropWidth,
  //             cropHeight, // Source dimensions (cropped portion)
  //             0,
  //             0,
  //             cropWidth,
  //             cropHeight, // Destination dimensions (full canvas size)
  //           )
  //         } else {
  //           hiddenCanvas.width = videoWidth
  //           hiddenCanvas.height = videoHeight
  //           context?.drawImage(
  //             this.videoElement,
  //             0,
  //             0,
  //             videoWidth,
  //             videoHeight, // Full source dimensions
  //             0,
  //             0,
  //             videoWidth,
  //             videoHeight,
  //           )
  //         }
  //         const { offsetWidth: elementWidth, offsetHeight: elementHeight } = this.videoElement
  //         const aspectRatioElement = elementWidth / elementHeight
  //         const aspectRatioVideo = videoWidth / videoHeight
  //         // context?.drawImage(
  //         //   this.videoElement,
  //         //   0,
  //         //   0,
  //         //   videoWidth,
  //         //   videoHeight, // Full source dimensions
  //         //   0,
  //         //   0,
  //         //   videoWidth,
  //         //   videoHeight // Full destination dimensions
  //         // );
  //         // let cropWidth, cropHeight, cropX, cropY;

  //         // if (aspectRatioElement > aspectRatioVideo) {
  //         //   cropWidth = videoWidth;
  //         //   cropHeight = videoWidth / aspectRatioElement;
  //         //   cropX = 0;
  //         //   cropY = (videoHeight - cropHeight) / 2;
  //         // } else {
  //         //   cropHeight = videoHeight;
  //         //   cropWidth = videoHeight * aspectRatioElement;
  //         //   cropX = (videoWidth - cropWidth) / 2;
  //         //   cropY = 0;
  //         // }

  //         // Draw the full video frame on the canvas
  //         // context?.drawImage(
  //         //   this.videoElement,
  //         //   cropX,
  //         //   cropY,
  //         //   cropWidth,
  //         //   cropHeight, // Full source dimensions
  //         //   0,
  //         //   0,
  //         //   hiddenCanvas.width,
  //         //   hiddenCanvas.height // Full destination dimensions
  //         // );

  //         // Get the image data from the canvas
  //         // const imageData = context?.getImageData(0, 0, videoWidth, videoHeight);
  //         // if (!imageData) {
  //         //   throw new Error('Failed to get image data.');
  //         // }
  //         let jpegBlob
  //         if (hiddenCanvas) {
  //           jpegBlob = await new Promise<Blob>((resolve, reject) => {
  //             hiddenCanvas.toBlob(
  //               (blob) => {
  //                 if (blob) {
  //                   resolve(blob)
  //                 } else {
  //                   reject(new Error('Failed to convert canvas to JPEG.'))
  //                 }
  //               },
  //               'image/jpeg',
  //               1,
  //             ) // Adjust 0.7 to a value between 0 (low quality) and 1 (high quality)
  //           })
  //         }

  //         // const pngBlob = await new Promise<Blob>((resolve, reject) => {
  //         //   hiddenCanvas.toBlob((blob) => {
  //         //     if (blob) {
  //         //       resolve(blob);
  //         //     } else {
  //         //       reject(new Error('Failed to convert canvas to PNG.'));
  //         //     }
  //         //   }, 'image/png');
  //         // });
  //         // const arrayBuffer = await pngBlob.arrayBuffer();
  //         // const buffer = Buffer.from(arrayBuffer);
  //         // const base64Data = await new Promise<string>((resolve, reject) => {
  //         //   const reader = new FileReader();
  //         //   reader.onloadend = () => resolve(reader.result as string);
  //         //   reader.onerror = reject;
  //         //   reader.readAsDataURL(pngBlob); // Convert blob to Base64
  //         // });
  //         // console.log('png data', base64Data);

  //         // Convert the uncompressed image to Base64
  //         // const uncompressedBase64 = await new Promise<string>((resolve, reject) => {
  //         //   hiddenCanvas.toBlob(
  //         //     (blob) => {
  //         //       if (blob) {
  //         //         const reader = new FileReader();
  //         //         reader.onloadend = () => resolve(reader.result as string);
  //         //         reader.onerror = reject;
  //         //         reader.readAsDataURL(blob);
  //         //       } else {
  //         //         reject(new Error('Failed to create Blob for uncompressed image.'));
  //         //       }
  //         //     },
  //         //     'image/png'
  //         //   );
  //         // });

  //         // console.log(`Image ${imageIndex + 1} Uncompressed Base64: ${uncompressedBase64}`);
  //         const arrayBuffer = await jpegBlob.arrayBuffer()
  //         const buffer = Buffer.from(arrayBuffer)
  //         // Compress the image using UPNG.js
  //         // const compressedData = UPNG.encode([imageData.data.buffer], videoWidth, videoHeight, 256);

  //         // Convert the compressed data to Base64
  //         // const compressedBase64 = await new Promise<string>((resolve, reject) => {
  //         //   const blob = new Blob([compressedData], { type: 'image/png' });
  //         //   const reader = new FileReader();
  //         //   reader.onloadend = () => resolve(reader.result as string);
  //         //   reader.onerror = reject;
  //         //   reader.readAsDataURL(blob);
  //         // });

  //         // Log image resolution, size, and Base64
  //         // console.log(`Image ${imageIndex + 1} Resolution: ${videoWidth}x${videoHeight}`);
  //         // console.log(`Compressed PNG Size: ${(compressedData.byteLength / 1024).toFixed(2)} KB`);
  //         // console.log(`Compressed PNG Base64: ${compressedBase64}`);

  //         const MQTT_TOPIC_POST_IMAGE = this.topicName
  //           ? `image-stream/${this.topicName}`
  //           : `stream/images/${this.sessionId}`

  //         // Publish the compressed image to MQTT
  //         if (this.peerConnection) {
  //           const mongoId = this.generateMongoId()
  //           const msg = JSON.stringify({
  //             image: buffer,
  //             imageId: mongoId,
  //             sessionId: this.sessionId,
  //           })
  //           // console.log(
  //           //   'Publishing compressed image binary data to MQTT topic',
  //           //   MQTT_TOPIC_POST_IMAGE,
  //           //   msg,
  //           // )
  //           // this.showToast('Test Msg: Images Sent, Please wait');
  //           //this.mqttClient?.publish(MQTT_TOPIC_POST_IMAGE, msg)
  //         }

  //         this.stopDisplayingMessages()
  //         // console.log(`Image ${imageIndex + 1} sent successfully to ${MQTT_TOPIC_POST_IMAGE}`)
  //       } catch (error) {
  //         console.error(`Error capturing or sending image ${imageIndex + 1}:`, error)
  //       }
  //     }

  //     let imagesSent = 0
  //     this.interval = setInterval(async () => {
  //       if (this.terminateImageSending) {
  //         clearInterval(this.interval)
  //         this.interval = null // Stop when all images are sent or termination is requested
  //         console.log('Image sending process terminated.')
  //         this.sendImagesToTopic = false // Reset the flag
  //         return
  //       }

  //       await publishImage(imagesSent++)
  //     }, 142)
  //   } catch (error) {
  //     console.log('Image sending process terminated.11', error)
  //     console.error('Error handling video stream:', error)
  //   }
  // }
  // public stopImageSending() {
  //   this.terminateImageSending = true
  // }

  // private generateMongoId() {
  //   const timestamp = Math.floor(new Date().getTime() / 1000).toString(16) // Timestamp in seconds (4 bytes)
  //   const randomBytes = Array.from(window.crypto.getRandomValues(new Uint8Array(12))) // 12 random bytes
  //     .map((byte) => byte.toString(16).padStart(2, '0')) // Convert to hexadecimal and pad with leading zeros
  //     .join('')
  //   return (timestamp + randomBytes.slice(0, 16)).toLowerCase() // Combine timestamp and random bytes
  // }
  // private showToast(message: string) {
  //     const toast = document.getElementById('toast')
  //     if (toast) {
  //       toast.textContent = message
  //       toast.style.opacity = '1'
  //     }
  //   }
  //   private hideToast() {
  //     const toast = document.getElementById('toast')
  //     if (toast) {
  //       toast.style.opacity = '0'
  //     }
  //   }
  // private createToastContainer() {
  //   const toast = document.createElement('div')
  //   toast.id = 'toast'
  //   toast.style.position = 'absolute'
  //   toast.style.top = '20px'
  //   toast.style.left = '50%'
  //   toast.style.transform = 'translateX(-50%)'
  //   toast.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'
  //   toast.style.color = '#fff'
  //   toast.style.padding = '10px 20px'
  //   toast.style.borderRadius = '30px' // Increased border-radius for rounded button shape
  //   toast.style.fontSize = '13px'
  //   toast.style.fontFamily = 'Arial, sans-serif'
  //   toast.style.zIndex = '9999'
  //   toast.style.opacity = '0'
  //   toast.style.transition = 'opacity 0.3s ease-in-out'
  //   document.body.appendChild(toast)
  //   return toast
  // }

  /* ----- Bandwidth Monitoring ----- */
  private monitorBandwidth(peerConnection, callback) {
    let intervalId = null
    let lastBytesSent = 0
    let lastTimestamp = 0

    // Start monitoring when streaming is active and peer connection exists
    if (peerConnection) {
      intervalId = setInterval(async () => {
        try {
          if (peerConnection) {
            const stats = await peerConnection.getStats()
            stats.forEach((report) => {
              if (report.type === 'outbound-rtp' && report.kind === 'video') {
                if (lastTimestamp && report.timestamp) {
                  const timeDiff = (report.timestamp - lastTimestamp) / 1000 // Convert ms to seconds
                  const bytesDiff = report.bytesSent - lastBytesSent
                  const bitrate = (bytesDiff * 8) / timeDiff / 1000000 // Convert to Mbps
                  const bandwidth = Number(bitrate.toFixed(2)) // Round to 2 decimals
                  callback(bandwidth) // Send bandwidth value to callback
                }
                lastBytesSent = report.bytesSent
                lastTimestamp = report.timestamp
              }
            })
          }
        } catch (error) {
          webLogger.error('Error getting bandwidth stats', error)
          console.error('Error getting bandwidth stats:', error)
        }
      }, 1000) // Check every second
    }

    // Return cleanup function
    return function stopMonitoring() {
      if (intervalId) {
        clearInterval(intervalId)
        intervalId = null
      }
    }
  }
  private startBandwidthMonitoring() {
    this.stopMonitoring = this.monitorBandwidth(this.peerConnection, (bandwidth) => {
      console.log(`Current bandwidth: ${bandwidth} Mbps`)
      this.bandwidth = bandwidth
      const textElement = document.getElementById('top-right-text-element')
      if (textElement) {
        this.updateTopRightText(`${this.bandwidth} Mbps`)
      } else {
        this.createTopRightText(`${this.bandwidth} Mbps`)
      }
    })
  }
  private stopBandwidthMonitoring() {
    if (this.stopMonitoring) {
      this.stopMonitoring()
    }
  }

  private updateTopRightText(newText) {
    const textElement = document.getElementById('top-right-text-element')
    if (textElement) {
      textElement.innerText = newText
    } else {
      console.warn('Top-right text element not found for update')
    }
  }

  private createTopRightText(text = '', background = '#000000') {
    const textElement = document.createElement('div')
    textElement.classList.add('top-right-text')
    textElement.id = 'top-right-text-element'
    // Positioning
    textElement.style.position = 'absolute'
    textElement.style.top = '10px' // Small offset from top
    textElement.style.right = '10px' // Small offset from right

    // Styling
    textElement.style.background = background
    textElement.style.color = '#ffffff' // White text
    textElement.style.padding = '4px 8px' // Smaller padding for small size
    textElement.style.fontSize = '10px' // Small text size
    textElement.style.borderRadius = '4px' // Smaller radius for small element
    textElement.style.zIndex = '11'
    textElement.style.fontFamily = 'Open Sans'
    textElement.style.fontWeight = 'normal'
    textElement.style.lineHeight = '1' // Tight line height for small text

    // Set text content
    textElement.innerText = text

    // Add to overlay
    this.overlay.appendChild(textElement)
  }
  private createTimerDisplay(background = '#000000') {
    const timerElement = document.createElement('div')
    timerElement.classList.add('top-right-timer')
    timerElement.id = 'top-right-timer-element'

    // Positioning
    timerElement.style.position = 'absolute'
    timerElement.style.top = '10px' // Matches createTopRightText
    timerElement.style.right = '80px' // Offset to the left of top-right-text (10px + text width ~60px + gap)

    // Styling (mirrors createTopRightText)
    timerElement.style.background = background
    timerElement.style.color = '#ffffff' // White text
    timerElement.style.padding = '4px 8px' // Smaller padding
    timerElement.style.fontSize = '10px' // Small text size
    timerElement.style.borderRadius = '4px' // Smaller radius
    timerElement.style.zIndex = '11'
    timerElement.style.fontFamily = 'Open Sans'
    timerElement.style.fontWeight = 'normal'
    timerElement.style.lineHeight = '1' // Tight line height

    // Function to format and update the timer
    const updateTimer = () => {
      const now = Date.now()
      const elapsed = Math.floor((now - this.startTime) / 1000) // Seconds elapsed
      const minutes = Math.floor(elapsed / 60)
        .toString()
        .padStart(2, '0')
      const seconds = (elapsed % 60).toString().padStart(2, '0')
      timerElement.innerText = `${minutes}:${seconds}`
    }

    // Initial update
    updateTimer()

    // Update every second
    const intervalId = setInterval(updateTimer, 1000)
    this.overlay.appendChild(timerElement)
  }
  private removeTopRightText() {
    if (this.overlay) {
      const textElements = this.overlay.getElementsByClassName('top-right-text')
      Array.from(textElements).forEach((element) => element.remove())
    }
  }
}